<template>
  <!-- 内容区域 -->
  <div>    
    <div class="dashboard-tab">
      <h3 class="tab-title">套餐与流量包</h3>

    <div class="tab-bar"> 
      <span :class="tab_class_1" @click="set_tab_active(1)">套餐</span>
      <span :class="tab_class_2" @click="set_tab_active(2)">流量包</span>
  </div>

      <div v-if="tab_class_1=='tab-active'">     
       <a class="info-text" v-if="tenantInfo.versionName==null">
   <svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5554" width="16" height="16"><path d="M597.333333 119.466667c0 4.266667 8.533333 12.8 21.333334 34.133333s25.6 42.666667 42.666666 76.8 38.4 64 59.733334 102.4c21.333333 38.4 46.933333 76.8 68.266666 115.2 21.333333 38.4 46.933333 81.066667 68.266667 119.466667 21.333333 38.4 42.666667 76.8 64 106.666666 17.066667 34.133333 34.133333 59.733333 51.2 85.333334s21.333333 38.4 29.866667 46.933333c8.533333 17.066667 17.066667 34.133333 17.066666 51.2 4.266667 17.066667 0 29.866667-4.266666 46.933333s-12.8 25.6-21.333334 34.133334c-12.8 8.533333-25.6 12.8-42.666666 12.8H89.6c-25.6 0-46.933333-4.266667-59.733333-12.8-12.8-8.533333-21.333333-21.333333-25.6-34.133334-4.266667-12.8-4.266667-29.866667 0-42.666666 4.266667-17.066667 8.533333-29.866667 21.333333-46.933334 4.266667-8.533333 12.8-21.333333 25.6-46.933333 12.8-21.333333 29.866667-51.2 51.2-81.066667 21.333333-34.133333 42.666667-68.266667 64-106.666666 21.333333-38.4 46.933333-81.066667 72.533333-119.466667s46.933333-81.066667 68.266667-119.466667c21.333333-38.4 42.666667-72.533333 59.733333-102.4 17.066667-29.866667 34.133333-55.466667 46.933334-76.8l21.333333-34.133333c8.533333-12.8 21.333333-25.6 38.4-34.133333 17.066667-8.533333 29.866667-12.8 46.933333-12.8s29.866667 4.266667 46.933334 8.533333c8.533333 4.266667 21.333333 17.066667 29.866666 29.866667z m-25.6 196.266666c0-8.533333 0-17.066667-4.266666-21.333333-4.266667-8.533333-8.533333-12.8-12.8-17.066667-4.266667-4.266667-12.8-8.533333-21.333334-12.8s-17.066667-8.533333-25.6-8.533333c-17.066667 0-29.866667 4.266667-42.666666 17.066667s-21.333333 25.6-21.333334 42.666666v264.533334c0 17.066667 8.533333 29.866667 21.333334 42.666666s25.6 17.066667 42.666666 17.066667 29.866667-4.266667 42.666667-17.066667c12.8-12.8 21.333333-25.6 21.333333-42.666666v-264.533334z m-64 384c-17.066667 0-34.133333 4.266667-42.666666 17.066667s-17.066667 25.6-17.066667 42.666667 4.266667 34.133333 17.066667 42.666666c12.8 12.8 25.6 17.066667 42.666666 17.066667s34.133333-4.266667 42.666667-17.066667c12.8-12.8 17.066667-25.6 17.066667-42.666666s-4.266667-34.133333-17.066667-42.666667c-8.533333-12.8-25.6-17.066667-42.666667-17.066667z" fill="#1296db" p-id="5555"></path></svg>        
        您没有购买套餐，暂时无法配置和部署专属AI客服。</a>
       <el-button type="text"  class="button" v-if="tenantInfo.versionName==null" @click="HandlePlanSelector">选择套餐</el-button>
        <img v-if="tenantInfo.versionName==null" src="https://aics-public.oss-cn-beijing.aliyuncs.com/images/aics-demo.jpg" class="aics-background"/>

                  <!-- 套餐信息展示 -->
      <div v-if="tenantInfo.versionName!==null &&tab_class_1=='tab-active'" class="current-plan">
        <el-card class="plan-card" v-if="tenantInfo.versionName!=null">
          <div slot="header" class="clearfix">
            <span class="plan-title">当前套餐：{{ tenantInfo.versionName }}</span>
             <el-button style="float: right; padding: 3px 0;margin-left: 10px;" type="text" @click="HandlePlanUpgrade">升级配置</el-button>
            <el-button style="float: right; padding: 3px 0" type="text" @click="open_renew=true">续费</el-button>  
          </div>
          <div class="plan-info">
            <div class="plan-item">
              <span class="label">月度对话量额度：<a title="套餐中包含的AI客服对话数量，AI客服每回复一次客户的提问，就会消耗1次" style="margin-left: 10px; width:24px;cursor: pointer;"><svg t="1792234811368" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5642" width="24" height="24"><path d="M473.6 460.8l-81.066667 25.6c-4.266667-12.8-8.533333-25.6-8.533333-38.4C384 388.266667 430.933333 341.333333 490.666667 341.333333h42.666666c59.733333 0 106.666667 46.933333 106.666667 106.666667 0 51.2-38.4 93.866667-85.333333 102.4v4.266667h-85.333334v-85.333334h64c12.8 0 21.333333-8.533333 21.333334-21.333333s-8.533333-21.333333-21.333334-21.333333h-42.666666c-12.8 0-21.333333 8.533333-21.333334 21.333333 0 4.266667 0 8.533333 4.266667 12.8zM512 853.333333c-187.733333 0-341.333333-153.6-341.333333-341.333333s153.6-341.333333 341.333333-341.333333 341.333333 153.6 341.333333 341.333333-153.6 341.333333-341.333333 341.333333z m0-85.333333c140.8 0 256-115.2 256-256s-115.2-256-256-256-256 115.2-256 256 115.2 256 256 256z m-42.666667-170.666667h85.333334v85.333334h-85.333334v-85.333334z" fill="#1296db" p-id="5643"></path></svg></a></span>
              <span class="value">{{ tenantInfo.monthlyConversationCount }}次</span>
            </div>
            <div class="plan-item">
              <span class="label">已消费对话量：</span>
              <span class="value">{{    (costConversations<0?0:costConversations) }}次</span>
              <a class="link" v-if="costConversations>0"  @click="show_consume_details(/*tenantInfo.versionName, tenantInfo.tenantId*/)">查看详情</a>
            </div>            
                        <div class="plan-item">
              <span class="label">剩余对话量：</span>
              <span class="value">{{ ((tenantInfo.monthlyConversationCount>costConversations)?tenantInfo.monthlyConversationCount-costConversations:0) }}次</span>
         
            </div>
            <div class="plan-item">
              <span class="label">购买日期：</span>
              <span v-if="tenantInfo && tenantInfo.createdAt" class="value">{{formatDateTime(tenantInfo.createdAt)}}          
              </span>
            </div>
            <div class="plan-item">
              <span class="label">起止时间：</span>
              <span class="value"  v-if="tenantInfo && tenantInfo.versionStartDate && tenantInfo.versionEndDate">
                {{ tenantInfo.versionStartDate}}
                ~ 
                {{ tenantInfo.versionEndDate}}</span>
            </div>

            <div class="plan-item">
              <span class="label">有效期剩余天数：</span>
              <span class="value"  v-if="tenantInfo && tenantInfo.versionStartDate && tenantInfo.versionEndDate">
                {{ tenantInfo.validDaysLeft}}天</span>
            </div>            
          </div>
        </el-card>
      </div>
    

      </div>
         <!-- 加油包区域 -->
          <div v-if="tab_class_2=='tab-active'">            
          <a class="info-text" v-if="my_fuel_packages==null || my_fuel_packages.length==0">
            <svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5554" width="16" height="16"><path d="M597.333333 119.466667c0 4.266667 8.533333 12.8 21.333334 34.133333s25.6 42.666667 42.666666 76.8 38.4 64 59.733334 102.4c21.333333 38.4 46.933333 76.8 68.266666 115.2 21.333333 38.4 46.933333 81.066667 68.266667 119.466667 21.333333 38.4 42.666667 76.8 64 106.666666 17.066667 34.133333 34.133333 59.733333 51.2 85.333334s21.333333 38.4 29.866667 46.933333c8.533333 17.066667 17.066667 34.133333 17.066666 51.2 4.266667 17.066667 0 29.866667-4.266666 46.933333s-12.8 25.6-21.333334 34.133334c-12.8 8.533333-25.6 12.8-42.666666 12.8H89.6c-25.6 0-46.933333-4.266667-59.733333-12.8-12.8-8.533333-21.333333-21.333333-25.6-34.133334-4.266667-12.8-4.266667-29.866667 0-42.666666 4.266667-17.066667 8.533333-29.866667 21.333333-46.933334 4.266667-8.533333 12.8-21.333333 25.6-46.933333 12.8-21.333333 29.866667-51.2 51.2-81.066667 21.333333-34.133333 42.666667-68.266667 64-106.666666 21.333333-38.4 46.933333-81.066667 72.533333-119.466667s46.933333-81.066667 68.266667-119.466667c21.333333-38.4 42.666667-72.533333 59.733333-102.4 17.066667-29.866667 34.133333-55.466667 46.933334-76.8l21.333333-34.133333c8.533333-12.8 21.333333-25.6 38.4-34.133333 17.066667-8.533333 29.866667-12.8 46.933333-12.8s29.866667 4.266667 46.933334 8.533333c8.533333 4.266667 21.333333 17.066667 29.866666 29.866667z m-25.6 196.266666c0-8.533333 0-17.066667-4.266666-21.333333-4.266667-8.533333-8.533333-12.8-12.8-17.066667-4.266667-4.266667-12.8-8.533333-21.333334-12.8s-17.066667-8.533333-25.6-8.533333c-17.066667 0-29.866667 4.266667-42.666666 17.066667s-21.333333 25.6-21.333334 42.666666v264.533334c0 17.066667 8.533333 29.866667 21.333334 42.666666s25.6 17.066667 42.666666 17.066667 29.866667-4.266667 42.666667-17.066667c12.8-12.8 21.333333-25.6 21.333333-42.666666v-264.533334z m-64 384c-17.066667 0-34.133333 4.266667-42.666666 17.066667s-17.066667 25.6-17.066667 42.666667 4.266667 34.133333 17.066667 42.666666c12.8 12.8 25.6 17.066667 42.666666 17.066667s34.133333-4.266667 42.666667-17.066667c12.8-12.8 17.066667-25.6 17.066667-42.666666s-4.266667-34.133333-17.066667-42.666667c-8.533333-12.8-25.6-17.066667-42.666667-17.066667z" fill="#1296db" p-id="5555"></path></svg>             
            您没有购买流量包，如果对话数量不足，AI客服将无法正常对话。
          </a>
          
          <el-button  type="text" style="margin-left: 50px;" @click="HandleFuelpackageSelector">购买流量包</el-button>
          <img v-if="my_fuel_packages==null || my_fuel_packages.length==0" src="https://aics-public.oss-cn-beijing.aliyuncs.com/images/aics-demo.jpg" class="aics-background"/>
            <div v-if="my_fuel_packages!==null  && my_fuel_packages.length>0" class="fuel-package-section">           
        <div class="fuel-package-list"  v-for="pkg in my_fuel_packages" :key="pkg.id">  
          <el-card :key="pkg.id" class="fuel-card">
    <!--       :class="{ 'selected': selectedFuelPackageId === pkg.id }"
            @click.native="selectFuelPackage(pkg)" -->
            <div class="fuel-header">
              <h3 style="margin: 0 5px 5px 5px;">{{ pkg.package_name }}</h3>
              <el-tag v-if="pkg.status === 1" type="success" size="mini">上架中</el-tag>
            </div>
            <div class="fuel-content">
              <div class="fuel-detail">
                <span class="label">额定对话量：</span>
                <span class="value">{{ pkg.conversation_count }}次</span>
              </div>
              <div class="fuel-detail">
                <span class="label">已消费对话量：</span>
                <span class="value">{{ pkg.convertsation_used>0?pkg.convertsation_used:0 }}次</span>
                              <a class="link" v-if=" pkg.convertsation_used>0"  @click="show_consume_details_fuel(pkg.package_name, tenantInfo.tenantId)">查看详情</a>
              </div>
              <div class="fuel-detail">
                <span class="label">剩余对话量：</span>
                <span class="value">{{  pkg.conversation_count>=pkg.convertsation_used? pkg.conversation_count-pkg.convertsation_used: 0 }}次</span>
              </div>
              <div class="fuel-detail">
                <span class="label">生效日期：</span>
                <span class="value">{{  pkg.start_date }}</span>
              </div>              
              <!--div class="fuel-price">
                <span class="original-price" v-if="pkg.originalPrice > pkg.currentPrice">
                  ¥{{ pkg.originalPrice }}
                </span>
                <span class="current-price">¥{{ pkg.currentPrice }}</span>
              </div >
              <div class="fuel-action">
                <el-button type="primary" size="small" @click.stop="addFuelToCart(pkg)">
                  <i class="el-icon-shopping-cart-2"></i> 加入购物车
                </el-button >
              </div -->
            </div>
          </el-card>
        </div>
      </div> 
       

   
    </div>
      <!-- 选择套餐对话框--> 
      <el-dialog title="选择套餐" :visible.sync="open_plan" width="1024px" append-to-body>
          <div class="selector">
              <ul>
                <li v-for="version in version_settings" :key="version.versionCode"  @click="HandleSelect_plan(version.versionCode)">                 
                  <svg v-if="version.versionCode===versionCode_selected" t="1765097638652" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5754" width="16" height="16"><path d="M665.937162 312.460799H501.981533a30.012721 30.012721 0 0 0 0 60.025441h163.955629a30.012721 30.012721 0 1 0 0-60.025441z m-265.850301-13.66916h-59.876863a14.857782 14.857782 0 0 0-14.753778 14.857783v58.836818a14.73892 14.73892 0 0 0 14.753778 14.857783h59.876863a14.753778 14.753778 0 0 0 14.753778-14.857783V313.649422a14.857782 14.857782 0 0 0-14.753778-14.857783z m0 147.092046h-59.876863a14.857782 14.857782 0 0 0-14.753778 14.709205v59.876863a14.857782 14.857782 0 0 0 14.753778 14.857783h59.876863a14.857782 14.857782 0 0 0 14.753778-14.857783v-59.876863a14.857782 14.857782 0 0 0-14.753778-14.709205z m0 149.023558h-59.876863a14.857782 14.857782 0 0 0-14.753778 14.857783v59.728285a14.857782 14.857782 0 0 0 14.753778 14.857782h59.876863a14.857782 14.857782 0 0 0 14.753778-14.857782v-59.728285a14.857782 14.857782 0 0 0-14.753778-14.857783zM784.73999 1023.851422a44.573347 44.573347 0 0 1-30.978476-12.480537l-106.411438-88.255228-106.39658 88.255228a44.766498 44.766498 0 0 1-62.016384 0l-106.426295-88.255228-102.266117 84.243627a44.424769 44.424769 0 0 1-62.046099 0l-106.678878-102.815855a44.707067 44.707067 0 0 1-13.698876-32.09281V81.125126A75.952984 75.952984 0 0 1 164.085844 0.001634h570.71714a44.350481 44.350481 0 0 1 31.394494 12.926271l156.734747 149.915025a43.889889 43.889889 0 0 1 13.297715 31.795654v685.983815a44.855645 44.855645 0 0 1-13.594871 32.092811l-104.747366 98.655675a49.907291 49.907291 0 0 1-33.147713 12.480537zM372.510817 816.288202a44.573347 44.573347 0 0 1 31.008191 12.480537l106.426296 102.667276 106.381722-102.667276a44.781356 44.781356 0 0 1 62.031242 0l106.381722 88.403805 62.17982-55.568106-1.797792-607.83188H713.095763a30.681321 30.681321 0 0 1-30.577316-30.607031V89.296907H177.190409v764.135751l62.031241 59.728285 102.266117-84.392204a44.677352 44.677352 0 0 1 31.02305-12.480537z m293.426345-356.141046H501.981533a29.938432 29.938432 0 1 0 0 59.876864h163.955629a29.938432 29.938432 0 1 0 0-59.876864z m0 148.87498H501.981533a30.012721 30.012721 0 0 0 0 60.025442h163.955629a30.012721 30.012721 0 1 0 0-60.025442z" fill="#1296db" p-id="5755"></path></svg>                  
                  <svg  v-if="version.versionCode!==versionCode_selected" t="1765097638652" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5754" width="16" height="16"><path d="M665.937162 312.460799H501.981533a30.012721 30.012721 0 0 0 0 60.025441h163.955629a30.012721 30.012721 0 1 0 0-60.025441z m-265.850301-13.66916h-59.876863a14.857782 14.857782 0 0 0-14.753778 14.857783v58.836818a14.73892 14.73892 0 0 0 14.753778 14.857783h59.876863a14.753778 14.753778 0 0 0 14.753778-14.857783V313.649422a14.857782 14.857782 0 0 0-14.753778-14.857783z m0 147.092046h-59.876863a14.857782 14.857782 0 0 0-14.753778 14.709205v59.876863a14.857782 14.857782 0 0 0 14.753778 14.857783h59.876863a14.857782 14.857782 0 0 0 14.753778-14.857783v-59.876863a14.857782 14.857782 0 0 0-14.753778-14.709205z m0 149.023558h-59.876863a14.857782 14.857782 0 0 0-14.753778 14.857783v59.728285a14.857782 14.857782 0 0 0 14.753778 14.857782h59.876863a14.857782 14.857782 0 0 0 14.753778-14.857782v-59.728285a14.857782 14.857782 0 0 0-14.753778-14.857783zM784.73999 1023.851422a44.573347 44.573347 0 0 1-30.978476-12.480537l-106.411438-88.255228-106.39658 88.255228a44.766498 44.766498 0 0 1-62.016384 0l-106.426295-88.255228-102.266117 84.243627a44.424769 44.424769 0 0 1-62.046099 0l-106.678878-102.815855a44.707067 44.707067 0 0 1-13.698876-32.09281V81.125126A75.952984 75.952984 0 0 1 164.085844 0.001634h570.71714a44.350481 44.350481 0 0 1 31.394494 12.926271l156.734747 149.915025a43.889889 43.889889 0 0 1 13.297715 31.795654v685.983815a44.855645 44.855645 0 0 1-13.594871 32.092811l-104.747366 98.655675a49.907291 49.907291 0 0 1-33.147713 12.480537zM372.510817 816.288202a44.573347 44.573347 0 0 1 31.008191 12.480537l106.426296 102.667276 106.381722-102.667276a44.781356 44.781356 0 0 1 62.031242 0l106.381722 88.403805 62.17982-55.568106-1.797792-607.83188H713.095763a30.681321 30.681321 0 0 1-30.577316-30.607031V89.296907H177.190409v764.135751l62.031241 59.728285 102.266117-84.392204a44.677352 44.677352 0 0 1 31.02305-12.480537z m293.426345-356.141046H501.981533a29.938432 29.938432 0 1 0 0 59.876864h163.955629a29.938432 29.938432 0 1 0 0-59.876864z m0 148.87498H501.981533a30.012721 30.012721 0 0 0 0 60.025442h163.955629a30.012721 30.012721 0 1 0 0-60.025442z" fill="#666666" p-id="5755"></path></svg>
                  <a :class="version.versionCode===versionCode_selected?'active':''">{{ version.versionName }}</a>
                </li>
              </ul>
            </div>
          <div v-if="current_version_setting !==null" class="plans-table-container">
            <table class="plans-table">
              <tbody>
                <tr>
                  <td class="feature-name">月费</td>
                  <td class="plan-feature"><a class="active">¥{{current_version_setting.monthlyPrice}}</a></td>
   <td class="feature-name">月度对话量上限</td>
                  <td class="plan-feature">{{current_version_setting.monthlyConversationCount}}次</td>    
   <td class="feature-name">最多AI客服中心数量</td>
                  <td class="plan-feature" colspan="3">{{current_version_setting.maxKbworkspaceCount}}个</td>                  
                </tr>                                                                
              </tbody>
            </table>       
        <div slot="footer" class="dialog-footer">
         
            <el-button
              type="text"
              style="margin-right: 10px;"
              @click="goToCart_plan">

              <svg t="1765539348895" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5888" width="16" height="16"><path d="M919.68 704H292.48l-160-576H28.8V64h152.32l160 576h525.12l52.16-288H412.8V288h582.4l-75.52 416zM380.8 960a96 96 0 1 1 96-96 96 96 0 0 1-96 96z m0-128a32 32 0 1 0 32 32 32 32 0 0 0-32-32zM796.8 960a96 96 0 1 1 96-96 96 96 0 0 1-96 96z m0-128a32 32 0 1 0 32 32 32 32 0 0 0-32-32z" fill="#1296db" p-id="5889"></path><path d="M476.8 416h64v160h-64zM668.8 416h64v160h-64z" fill="#1296db" p-id="5890"></path></svg>
              去购物车结算
            </el-button>
            <el-button type="primary" @click="addPlanToCart(current_version_setting)">                
                 加入购物车
              </el-button>          
          <el-button type="plain" @click="cancel_plan">取 消</el-button>
        </div>
        </div>
      </el-dialog>
      <!-- 选择流量包对话框--> 
      <el-dialog title="选择流量包" :visible.sync="open_fuel" width="1024px" append-to-body>
          <div class="selector">
              <ul>
                <li v-for="pkg in fuelPackages" :key="pkg.package_code"  @click="HandleSelect_fuel(pkg.package_code)">                 
                  <svg v-if="pkg.package_code===pkgCodeSelected" t="1765097638652" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5754" width="16" height="16"><path d="M665.937162 312.460799H501.981533a30.012721 30.012721 0 0 0 0 60.025441h163.955629a30.012721 30.012721 0 1 0 0-60.025441z m-265.850301-13.66916h-59.876863a14.857782 14.857782 0 0 0-14.753778 14.857783v58.836818a14.73892 14.73892 0 0 0 14.753778 14.857783h59.876863a14.753778 14.753778 0 0 0 14.753778-14.857783V313.649422a14.857782 14.857782 0 0 0-14.753778-14.857783z m0 147.092046h-59.876863a14.857782 14.857782 0 0 0-14.753778 14.709205v59.876863a14.857782 14.857782 0 0 0 14.753778 14.857783h59.876863a14.857782 14.857782 0 0 0 14.753778-14.857783v-59.876863a14.857782 14.857782 0 0 0-14.753778-14.709205z m0 149.023558h-59.876863a14.857782 14.857782 0 0 0-14.753778 14.857783v59.728285a14.857782 14.857782 0 0 0 14.753778 14.857782h59.876863a14.857782 14.857782 0 0 0 14.753778-14.857782v-59.728285a14.857782 14.857782 0 0 0-14.753778-14.857783zM784.73999 1023.851422a44.573347 44.573347 0 0 1-30.978476-12.480537l-106.411438-88.255228-106.39658 88.255228a44.766498 44.766498 0 0 1-62.016384 0l-106.426295-88.255228-102.266117 84.243627a44.424769 44.424769 0 0 1-62.046099 0l-106.678878-102.815855a44.707067 44.707067 0 0 1-13.698876-32.09281V81.125126A75.952984 75.952984 0 0 1 164.085844 0.001634h570.71714a44.350481 44.350481 0 0 1 31.394494 12.926271l156.734747 149.915025a43.889889 43.889889 0 0 1 13.297715 31.795654v685.983815a44.855645 44.855645 0 0 1-13.594871 32.092811l-104.747366 98.655675a49.907291 49.907291 0 0 1-33.147713 12.480537zM372.510817 816.288202a44.573347 44.573347 0 0 1 31.008191 12.480537l106.426296 102.667276 106.381722-102.667276a44.781356 44.781356 0 0 1 62.031242 0l106.381722 88.403805 62.17982-55.568106-1.797792-607.83188H713.095763a30.681321 30.681321 0 0 1-30.577316-30.607031V89.296907H177.190409v764.135751l62.031241 59.728285 102.266117-84.392204a44.677352 44.677352 0 0 1 31.02305-12.480537z m293.426345-356.141046H501.981533a29.938432 29.938432 0 1 0 0 59.876864h163.955629a29.938432 29.938432 0 1 0 0-59.876864z m0 148.87498H501.981533a30.012721 30.012721 0 0 0 0 60.025442h163.955629a30.012721 30.012721 0 1 0 0-60.025442z" fill="#1296db" p-id="5755"></path></svg>                  
                  <svg  v-if="pkg.package_code!==pkgCodeSelected" t="1765097638652" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5754" width="16" height="16"><path d="M665.937162 312.460799H501.981533a30.012721 30.012721 0 0 0 0 60.025441h163.955629a30.012721 30.012721 0 1 0 0-60.025441z m-265.850301-13.66916h-59.876863a14.857782 14.857782 0 0 0-14.753778 14.857783v58.836818a14.73892 14.73892 0 0 0 14.753778 14.857783h59.876863a14.753778 14.753778 0 0 0 14.753778-14.857783V313.649422a14.857782 14.857782 0 0 0-14.753778-14.857783z m0 147.092046h-59.876863a14.857782 14.857782 0 0 0-14.753778 14.709205v59.876863a14.857782 14.857782 0 0 0 14.753778 14.857783h59.876863a14.857782 14.857782 0 0 0 14.753778-14.857783v-59.876863a14.857782 14.857782 0 0 0-14.753778-14.709205z m0 149.023558h-59.876863a14.857782 14.857782 0 0 0-14.753778 14.857783v59.728285a14.857782 14.857782 0 0 0 14.753778 14.857782h59.876863a14.857782 14.857782 0 0 0 14.753778-14.857782v-59.728285a14.857782 14.857782 0 0 0-14.753778-14.857783zM784.73999 1023.851422a44.573347 44.573347 0 0 1-30.978476-12.480537l-106.411438-88.255228-106.39658 88.255228a44.766498 44.766498 0 0 1-62.016384 0l-106.426295-88.255228-102.266117 84.243627a44.424769 44.424769 0 0 1-62.046099 0l-106.678878-102.815855a44.707067 44.707067 0 0 1-13.698876-32.09281V81.125126A75.952984 75.952984 0 0 1 164.085844 0.001634h570.71714a44.350481 44.350481 0 0 1 31.394494 12.926271l156.734747 149.915025a43.889889 43.889889 0 0 1 13.297715 31.795654v685.983815a44.855645 44.855645 0 0 1-13.594871 32.092811l-104.747366 98.655675a49.907291 49.907291 0 0 1-33.147713 12.480537zM372.510817 816.288202a44.573347 44.573347 0 0 1 31.008191 12.480537l106.426296 102.667276 106.381722-102.667276a44.781356 44.781356 0 0 1 62.031242 0l106.381722 88.403805 62.17982-55.568106-1.797792-607.83188H713.095763a30.681321 30.681321 0 0 1-30.577316-30.607031V89.296907H177.190409v764.135751l62.031241 59.728285 102.266117-84.392204a44.677352 44.677352 0 0 1 31.02305-12.480537z m293.426345-356.141046H501.981533a29.938432 29.938432 0 1 0 0 59.876864h163.955629a29.938432 29.938432 0 1 0 0-59.876864z m0 148.87498H501.981533a30.012721 30.012721 0 0 0 0 60.025442h163.955629a30.012721 30.012721 0 1 0 0-60.025442z" fill="#666666" p-id="5755"></path></svg>
                  <a :class="pkg.package_code===pkgCodeSelected?'active':''">{{ pkg.package_name }}</a>
                </li>
              </ul>
            </div>
          <div v-if="current_fuel_package !==null" class="fuel-table-container">
            <table class="fuel-table">
              <tbody>
                <tr>
                  <td class="feature-name">价格</td>
                  <td class="plan-feature"><a class="active">¥{{current_fuel_package.current_price}}</a></td>
   <td class="feature-name">包含对话次数</td>
                  <td class="plan-feature">{{current_fuel_package.conversation_count}}次</td>    
   <td class="feature-name">有效期天数</td>
                  <td class="plan-feature">{{current_fuel_package.validity_days}}天</td>                  
                </tr>                                                                                              
              </tbody>
            </table>
          </div>            
        <div slot="footer" class="dialog-footer">
         
            <el-button
              type="text"
              style="margin-right: 10px;"
              @click="goToCart_fuel">

              <svg t="1765539348895" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5888" width="16" height="16"><path d="M919.68 704H292.48l-160-576H28.8V64h152.32l160 576h525.12l52.16-288H412.8V288h582.4l-75.52 416zM380.8 960a96 96 0 1 1 96-96 96 96 0 0 1-96 96z m0-128a32 32 0 1 0 32 32 32 32 0 0 0-32-32zM796.8 960a96 96 0 1 1 96-96 96 96 0 0 1-96 96z m0-128a32 32 0 1 0 32 32 32 32 0 0 0-32-32z" fill="#1296db" p-id="5889"></path><path d="M476.8 416h64v160h-64zM668.8 416h64v160h-64z" fill="#1296db" p-id="5890"></path></svg>
              去购物车结算
            </el-button>
            <el-button type="primary" @click="addFuelToCart(current_fuel_package)">                
                 加入购物车
              </el-button>          
          <el-button type="plain" @click="cancel_fuel">取 消</el-button>
        </div>
      </el-dialog>   

    <!-- 套餐升级配置对话框--> 
      <el-dialog title="套餐升级配置" :visible.sync="open_upgrade" width="1024px" append-to-body>
                <div class="progress-bar">

            <div class="step">
             <span class="step-no">1</span>
             <span class="step-text">选择套餐</span>

            </div>
            <div class="step">
                <span class="step-no">2</span>
             <span class="step-text">加入购物车</span>
            </div>
            <div class="step">
                <span class="step-no">3</span>
                <span class="step-text">去购物车结算</span>
            </div>          
        </div>
          <div class="selector">
            <a class="current_plan">当前套餐：{{ tenantInfo.versionName }}。您可以选择：</a>
              <ul>
                <li v-for="version in version_settings" :key="version.versionCode"  @click="HandleSelect_plan(version.versionCode)">                 
                  <svg v-if="canUpgrade(version.versionCode) && version.versionCode===versionCode_selected" t="1765097638652" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5754" width="16" height="16"><path d="M665.937162 312.460799H501.981533a30.012721 30.012721 0 0 0 0 60.025441h163.955629a30.012721 30.012721 0 1 0 0-60.025441z m-265.850301-13.66916h-59.876863a14.857782 14.857782 0 0 0-14.753778 14.857783v58.836818a14.73892 14.73892 0 0 0 14.753778 14.857783h59.876863a14.753778 14.753778 0 0 0 14.753778-14.857783V313.649422a14.857782 14.857782 0 0 0-14.753778-14.857783z m0 147.092046h-59.876863a14.857782 14.857782 0 0 0-14.753778 14.709205v59.876863a14.857782 14.857782 0 0 0 14.753778 14.857783h59.876863a14.857782 14.857782 0 0 0 14.753778-14.857783v-59.876863a14.857782 14.857782 0 0 0-14.753778-14.709205z m0 149.023558h-59.876863a14.857782 14.857782 0 0 0-14.753778 14.857783v59.728285a14.857782 14.857782 0 0 0 14.753778 14.857782h59.876863a14.857782 14.857782 0 0 0 14.753778-14.857782v-59.728285a14.857782 14.857782 0 0 0-14.753778-14.857783zM784.73999 1023.851422a44.573347 44.573347 0 0 1-30.978476-12.480537l-106.411438-88.255228-106.39658 88.255228a44.766498 44.766498 0 0 1-62.016384 0l-106.426295-88.255228-102.266117 84.243627a44.424769 44.424769 0 0 1-62.046099 0l-106.678878-102.815855a44.707067 44.707067 0 0 1-13.698876-32.09281V81.125126A75.952984 75.952984 0 0 1 164.085844 0.001634h570.71714a44.350481 44.350481 0 0 1 31.394494 12.926271l156.734747 149.915025a43.889889 43.889889 0 0 1 13.297715 31.795654v685.983815a44.855645 44.855645 0 0 1-13.594871 32.092811l-104.747366 98.655675a49.907291 49.907291 0 0 1-33.147713 12.480537zM372.510817 816.288202a44.573347 44.573347 0 0 1 31.008191 12.480537l106.426296 102.667276 106.381722-102.667276a44.781356 44.781356 0 0 1 62.031242 0l106.381722 88.403805 62.17982-55.568106-1.797792-607.83188H713.095763a30.681321 30.681321 0 0 1-30.577316-30.607031V89.296907H177.190409v764.135751l62.031241 59.728285 102.266117-84.392204a44.677352 44.677352 0 0 1 31.02305-12.480537z m293.426345-356.141046H501.981533a29.938432 29.938432 0 1 0 0 59.876864h163.955629a29.938432 29.938432 0 1 0 0-59.876864z m0 148.87498H501.981533a30.012721 30.012721 0 0 0 0 60.025442h163.955629a30.012721 30.012721 0 1 0 0-60.025442z" fill="#1296db" p-id="5755"></path></svg>                  
                  <svg  v-if="canUpgrade(version.versionCode) && version.versionCode!==versionCode_selected" t="1765097638652" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5754" width="16" height="16"><path d="M665.937162 312.460799H501.981533a30.012721 30.012721 0 0 0 0 60.025441h163.955629a30.012721 30.012721 0 1 0 0-60.025441z m-265.850301-13.66916h-59.876863a14.857782 14.857782 0 0 0-14.753778 14.857783v58.836818a14.73892 14.73892 0 0 0 14.753778 14.857783h59.876863a14.753778 14.753778 0 0 0 14.753778-14.857783V313.649422a14.857782 14.857782 0 0 0-14.753778-14.857783z m0 147.092046h-59.876863a14.857782 14.857782 0 0 0-14.753778 14.709205v59.876863a14.857782 14.857782 0 0 0 14.753778 14.857783h59.876863a14.857782 14.857782 0 0 0 14.753778-14.857783v-59.876863a14.857782 14.857782 0 0 0-14.753778-14.709205z m0 149.023558h-59.876863a14.857782 14.857782 0 0 0-14.753778 14.857783v59.728285a14.857782 14.857782 0 0 0 14.753778 14.857782h59.876863a14.857782 14.857782 0 0 0 14.753778-14.857782v-59.728285a14.857782 14.857782 0 0 0-14.753778-14.857783zM784.73999 1023.851422a44.573347 44.573347 0 0 1-30.978476-12.480537l-106.411438-88.255228-106.39658 88.255228a44.766498 44.766498 0 0 1-62.016384 0l-106.426295-88.255228-102.266117 84.243627a44.424769 44.424769 0 0 1-62.046099 0l-106.678878-102.815855a44.707067 44.707067 0 0 1-13.698876-32.09281V81.125126A75.952984 75.952984 0 0 1 164.085844 0.001634h570.71714a44.350481 44.350481 0 0 1 31.394494 12.926271l156.734747 149.915025a43.889889 43.889889 0 0 1 13.297715 31.795654v685.983815a44.855645 44.855645 0 0 1-13.594871 32.092811l-104.747366 98.655675a49.907291 49.907291 0 0 1-33.147713 12.480537zM372.510817 816.288202a44.573347 44.573347 0 0 1 31.008191 12.480537l106.426296 102.667276 106.381722-102.667276a44.781356 44.781356 0 0 1 62.031242 0l106.381722 88.403805 62.17982-55.568106-1.797792-607.83188H713.095763a30.681321 30.681321 0 0 1-30.577316-30.607031V89.296907H177.190409v764.135751l62.031241 59.728285 102.266117-84.392204a44.677352 44.677352 0 0 1 31.02305-12.480537z m293.426345-356.141046H501.981533a29.938432 29.938432 0 1 0 0 59.876864h163.955629a29.938432 29.938432 0 1 0 0-59.876864z m0 148.87498H501.981533a30.012721 30.012721 0 0 0 0 60.025442h163.955629a30.012721 30.012721 0 1 0 0-60.025442z" fill="#666666" p-id="5755"></path></svg>
                  <a    v-if="canUpgrade(version.versionCode)" :class="version.versionCode===versionCode_selected?'active':''">{{ version.versionName }}</a>
                </li>
              </ul>
            </div>
          <div v-if="current_version_setting !==null" class="plans-table-container">
            <a v-if="!show_plan_details" @click="show_plan_details=true" style="cursor:pointer; font-size9pt;cursor: pointer;color:rgb(64, 158, 255) ">展开套餐详情<svg style="margin-left: 10px;" t="1792381170518" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5617" width="16" height="16"><path d="M83.669902 444.757333L512.043236 816.071111l428.600888-371.256889a56.547556 56.547556 0 0 1 45.511112-11.377778 45.511111 45.511111 0 0 1 35.612444 24.974223 31.459556 31.459556 0 0 1-9.898667 36.522666l-455.793777 394.752a57.173333 57.173333 0 0 1-87.836445 0L12.445013 494.933333a31.914667 31.914667 0 0 1 3.584-52.963555 57.742222 57.742222 0 0 1 67.640889 2.787555z m472.177778 126.350223a57.173333 57.173333 0 0 1-87.836444 0L12.445013 176.355556a31.914667 31.914667 0 0 1 3.584-52.963556 57.742222 57.742222 0 0 1 67.584 2.787556L512.043236 497.493333l428.600888-371.256889a57.742222 57.742222 0 0 1 67.584-2.787555 31.914667 31.914667 0 0 1 3.584 52.736z" fill="#1296db" p-id="5618"></path></svg></a>
            <a v-if="show_plan_details" @click="show_plan_details=false" style="cursor:pointer; font-size: 9pt;  color:rgb(64, 158, 255);">收起套餐详情<svg style="margin-left: 10px;" t="1792381212856" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5900" width="16" height="16"><path d="M5.376 833.152l63.36 63.36 444.032-443.904L956.672 896.64 1020.032 833.152l-507.392-507.392-507.264 507.392zM512.768 183.552L956.672 627.584 1020.032 564.096l-507.392-507.392-507.392 507.392 63.36 63.35999999 444.16-443.90399999z" p-id="5901" fill="#1296db"></path></svg></a>            
            <table class="plans-table" v-if="show_plan_details">
              <tbody>
                <tr>
                  <td class="feature-name">目标客户</td>
                  <td class="plan-feature" :colspan="3"><a>{{current_version_setting.versionName=='试用版'?'新用户': (current_version_setting.versionName=='基础版'?'个体经营者、个人开发者':(current_version_setting.versionName=='团队版'?'中小团队':(current_version_setting.versionName=='企业版'?'有一定规模的企业':'-')))}}</a></td>
  
                  <td class="feature-name">核心价值</td>
                  <td class="plan-feature" :colspan="3"><a>{{current_version_setting.versionName=='试用版'?'体验功能、感知额度': (current_version_setting.versionName=='基础版'?'低成本获得 AI 客服基础能力':(current_version_setting.versionName=='团队版'?'多人协作的效率与一致性':(current_version_setting.versionName=='企业版'?'治理、合规与风险控制':'-')))}}</a></td>
                 
                </tr>                 
                <tr>
                  <td class="feature-name">月费</td>
                  <td class="plan-feature"><a class="active">¥{{current_version_setting.monthlyPrice}}</a></td>
   <td class="feature-name">月度对话量上限<a title="套餐中包含的AI客服对话数量，AI客服每回复一次客户的提问，就会消耗1次" style="margin-left: 10px; width:24px;cursor: pointer;"><svg t="1792234811368" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5642" width="24" height="24"><path d="M473.6 460.8l-81.066667 25.6c-4.266667-12.8-8.533333-25.6-8.533333-38.4C384 388.266667 430.933333 341.333333 490.666667 341.333333h42.666666c59.733333 0 106.666667 46.933333 106.666667 106.666667 0 51.2-38.4 93.866667-85.333333 102.4v4.266667h-85.333334v-85.333334h64c12.8 0 21.333333-8.533333 21.333334-21.333333s-8.533333-21.333333-21.333334-21.333333h-42.666666c-12.8 0-21.333333 8.533333-21.333334 21.333333 0 4.266667 0 8.533333 4.266667 12.8zM512 853.333333c-187.733333 0-341.333333-153.6-341.333333-341.333333s153.6-341.333333 341.333333-341.333333 341.333333 153.6 341.333333 341.333333-153.6 341.333333-341.333333 341.333333z m0-85.333333c140.8 0 256-115.2 256-256s-115.2-256-256-256-256 115.2-256 256 115.2 256 256 256z m-42.666667-170.666667h85.333334v85.333334h-85.333334v-85.333334z" fill="#1296db" p-id="5643"></path></svg></a></td>
                  <td class="plan-feature" >{{current_version_setting.monthlyConversationCount}}次</td>    
   <td class="feature-name">最多知识库 / AI客服中心数量<a title="知识库是AI知识库（AI knowledge base）的简称。它是一个集中式的数字存储库，旨在使用AI技术存储和组织信息，并提供对信息的访问。与传统的知识库不同，AI知识库是动态和交互式的。它使用机器学习和NLP技术使其能够从与用户的交互和它接收到的数据中学习、并不断更新。知识库就好像是AI模型（大语言模型）的图书馆，它是大语言模型获取外界信息的重要途径，大语言模型也会使用自己学习到的知识更新知识库的内容，因此，这是一个互动的过程。将使用知识库的应用被称称为代理（agent），比如客服机器人就是经典的知识库代理。您的AI客服之所以可以为您代言，知识库功不可没。 当您向知识库中上传了必要的文档后，就可以把知识库部署上线了。部署上线后的知识库就是AI客服中心。AI客服中心的本质还是知识库，但是知识库只供用户内部管理、配置和测试使用，您的客户不能直接访问这个知识库。我们将部署上线前的知识库成为主知识库、而AI客服中心会使用主知识库的 一个副本，为您的最终客户提供客服服务。" style="margin-left: 10px; width:24px;cursor: pointer;"><svg t="1792234811368" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5642" width="24" height="24"><path d="M473.6 460.8l-81.066667 25.6c-4.266667-12.8-8.533333-25.6-8.533333-38.4C384 388.266667 430.933333 341.333333 490.666667 341.333333h42.666666c59.733333 0 106.666667 46.933333 106.666667 106.666667 0 51.2-38.4 93.866667-85.333333 102.4v4.266667h-85.333334v-85.333334h64c12.8 0 21.333333-8.533333 21.333334-21.333333s-8.533333-21.333333-21.333334-21.333333h-42.666666c-12.8 0-21.333333 8.533333-21.333334 21.333333 0 4.266667 0 8.533333 4.266667 12.8zM512 853.333333c-187.733333 0-341.333333-153.6-341.333333-341.333333s153.6-341.333333 341.333333-341.333333 341.333333 153.6 341.333333 341.333333-153.6 341.333333-341.333333 341.333333z m0-85.333333c140.8 0 256-115.2 256-256s-115.2-256-256-256-256 115.2-256 256 115.2 256 256 256z m-42.666667-170.666667h85.333334v85.333334h-85.333334v-85.333334z" fill="#1296db" p-id="5643"></path></svg></a></td>
                  <td class="plan-feature" colspan="3">{{current_version_setting.maxKbworkspaceCount}}个</td>                  
                </tr>                                  
                <tr>
                  <td class="feature-name">最多AI客服席位数量最多AI客服席位数量<a title="一个AI客服中心可以包含多个AI客服席位。AI客服席位就是一个个嵌入网页中的AI客服图标，最终客户点击AI客服图标就可以打开对话窗口与AI客服对话了。一个AI客服席位就是一个网页中的一个AI客服图标吗？还不是这样的。一个AI客服席位需要绑定到一个域名，它只能部署在这个域名下。比如，您的官网域名是www.your-company.com，您的移动端网站的域名是m. your-company.com，这就是2个域名，对应2个AI客服席位。但是，一个域名下的网站又包含很多网页。部署AI客服中心就是将 AI客服中心页面中提供的一小段代码嵌入到您的网页中。因此一个AI客服席位可以包含一个域名下的多个网页中的AI客服图标。" style="margin-left: 10px; width:24px;cursor: pointer;"><svg t="1792234811368" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5642" width="24" height="24"><path d="M473.6 460.8l-81.066667 25.6c-4.266667-12.8-8.533333-25.6-8.533333-38.4C384 388.266667 430.933333 341.333333 490.666667 341.333333h42.666666c59.733333 0 106.666667 46.933333 106.666667 106.666667 0 51.2-38.4 93.866667-85.333333 102.4v4.266667h-85.333334v-85.333334h64c12.8 0 21.333333-8.533333 21.333334-21.333333s-8.533333-21.333333-21.333334-21.333333h-42.666666c-12.8 0-21.333333 8.533333-21.333334 21.333333 0 4.266667 0 8.533333 4.266667 12.8zM512 853.333333c-187.733333 0-341.333333-153.6-341.333333-341.333333s153.6-341.333333 341.333333-341.333333 341.333333 153.6 341.333333 341.333333-153.6 341.333333-341.333333 341.333333z m0-85.333333c140.8 0 256-115.2 256-256s-115.2-256-256-256-256 115.2-256 256 115.2 256 256 256z m-42.666667-170.666667h85.333334v85.333334h-85.333334v-85.333334z" fill="#1296db" p-id="5643"></path></svg></a></td>
                  <td class="plan-feature">{{current_version_setting.maxAicsSeatCount}}个</td>
   <td class="feature-name">知识库额度<a title="知识库额度是衡量您在 AI 客服中心可添加知识内容总量的计量单位。不同套餐包含不同的知识库额度，额度消耗规则为：一个问答对消耗1 点知识库额度，对于图文文档，每500 个字符（1个汉字相当于2个字符） = 1 点（不足 500 字按 1 点计），每 10 张图 = 1 点（不足 10 张按 1 点计）" style="margin-left: 10px; width:24px;cursor: pointer;"><svg t="1792234811368" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5642" width="24" height="24"><path d="M473.6 460.8l-81.066667 25.6c-4.266667-12.8-8.533333-25.6-8.533333-38.4C384 388.266667 430.933333 341.333333 490.666667 341.333333h42.666666c59.733333 0 106.666667 46.933333 106.666667 106.666667 0 51.2-38.4 93.866667-85.333333 102.4v4.266667h-85.333334v-85.333334h64c12.8 0 21.333333-8.533333 21.333334-21.333333s-8.533333-21.333333-21.333334-21.333333h-42.666666c-12.8 0-21.333333 8.533333-21.333334 21.333333 0 4.266667 0 8.533333 4.266667 12.8zM512 853.333333c-187.733333 0-341.333333-153.6-341.333333-341.333333s153.6-341.333333 341.333333-341.333333 341.333333 153.6 341.333333 341.333333-153.6 341.333333-341.333333 341.333333z m0-85.333333c140.8 0 256-115.2 256-256s-115.2-256-256-256-256 115.2-256 256 115.2 256 256 256z m-42.666667-170.666667h85.333334v85.333334h-85.333334v-85.333334z" fill="#1296db" p-id="5643"></path></svg></a></td>
                  <td class="plan-feature">{{current_version_setting.kb_score}}点</td>    
   <td class="feature-name" >图片库容量<a title="图片库是图文文档中图片的来源。如果您希望您的AI客服具备图文并茂回复的能力，就需要将图片上传至图片库，并将其添加到图文文档中。" style="margin-left: 10px; width:24px;cursor: pointer;"><svg t="1792234811368" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5642" width="24" height="24"><path d="M473.6 460.8l-81.066667 25.6c-4.266667-12.8-8.533333-25.6-8.533333-38.4C384 388.266667 430.933333 341.333333 490.666667 341.333333h42.666666c59.733333 0 106.666667 46.933333 106.666667 106.666667 0 51.2-38.4 93.866667-85.333333 102.4v4.266667h-85.333334v-85.333334h64c12.8 0 21.333333-8.533333 21.333334-21.333333s-8.533333-21.333333-21.333334-21.333333h-42.666666c-12.8 0-21.333333 8.533333-21.333334 21.333333 0 4.266667 0 8.533333 4.266667 12.8zM512 853.333333c-187.733333 0-341.333333-153.6-341.333333-341.333333s153.6-341.333333 341.333333-341.333333 341.333333 153.6 341.333333 341.333333-153.6 341.333333-341.333333 341.333333z m0-85.333333c140.8 0 256-115.2 256-256s-115.2-256-256-256-256 115.2-256 256 115.2 256 256 256z m-42.666667-170.666667h85.333334v85.333334h-85.333334v-85.333334z" fill="#1296db" p-id="5643"></path></svg></a></td>
                  <td class="plan-feature" colspan="3">{{current_version_setting.maxImageSpace}}MB</td>    
                
                </tr>   
                <tr>
  <td class="feature-name">图片识别<a title="对于拥有图片识别权限的租户，最终用户在与您的AI客服进行沟通时，可以上传图片，您的AI客服，可以充分理解图片中包含的信息，并基于此与最终用户进行进一步的沟通。" style="margin-left: 10px; width:24px;cursor: pointer;"><svg t="1792234811368" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5642" width="24" height="24"><path d="M473.6 460.8l-81.066667 25.6c-4.266667-12.8-8.533333-25.6-8.533333-38.4C384 388.266667 430.933333 341.333333 490.666667 341.333333h42.666666c59.733333 0 106.666667 46.933333 106.666667 106.666667 0 51.2-38.4 93.866667-85.333333 102.4v4.266667h-85.333334v-85.333334h64c12.8 0 21.333333-8.533333 21.333334-21.333333s-8.533333-21.333333-21.333334-21.333333h-42.666666c-12.8 0-21.333333 8.533333-21.333334 21.333333 0 4.266667 0 8.533333 4.266667 12.8zM512 853.333333c-187.733333 0-341.333333-153.6-341.333333-341.333333s153.6-341.333333 341.333333-341.333333 341.333333 153.6 341.333333 341.333333-153.6 341.333333-341.333333 341.333333z m0-85.333333c140.8 0 256-115.2 256-256s-115.2-256-256-256-256 115.2-256 256 115.2 256 256 256z m-42.666667-170.666667h85.333334v85.333334h-85.333334v-85.333334z" fill="#1296db" p-id="5643"></path></svg></a></td>
                  <td class="plan-feature">{{current_version_setting.imageRecognition?'✓':'✗'}}</td>                   
                  <td class="feature-name">月图片识别数量上限<a title="对于拥有图片识别权限的租户，该指标定义您的AI客服在与最终用户进行沟通时，每月可以识别图片的最大数量。如果当前月识别图片的数量超过该指标，最终用户将不能上传图片给AI客服。" style="margin-left: 10px; width:24px;cursor: pointer;"><svg t="1792234811368" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5642" width="24" height="24"><path d="M473.6 460.8l-81.066667 25.6c-4.266667-12.8-8.533333-25.6-8.533333-38.4C384 388.266667 430.933333 341.333333 490.666667 341.333333h42.666666c59.733333 0 106.666667 46.933333 106.666667 106.666667 0 51.2-38.4 93.866667-85.333333 102.4v4.266667h-85.333334v-85.333334h64c12.8 0 21.333333-8.533333 21.333334-21.333333s-8.533333-21.333333-21.333334-21.333333h-42.666666c-12.8 0-21.333333 8.533333-21.333334 21.333333 0 4.266667 0 8.533333 4.266667 12.8zM512 853.333333c-187.733333 0-341.333333-153.6-341.333333-341.333333s153.6-341.333333 341.333333-341.333333 341.333333 153.6 341.333333 341.333333-153.6 341.333333-341.333333 341.333333z m0-85.333333c140.8 0 256-115.2 256-256s-115.2-256-256-256-256 115.2-256 256 115.2 256 256 256z m-42.666667-170.666667h85.333334v85.333334h-85.333334v-85.333334z" fill="#1296db" p-id="5643"></path></svg></a></td>
                  <td class="plan-feature">{{current_version_setting.monthlyImageRecognitionCount}}个</td>
         
   <td class="feature-name">AI客服图文并茂回复<a title="对于拥有图片识别权限的租户，您的AI客服在与最终用户进行沟通时，可以使用图片库中的图片回复最终用户。" style="margin-left: 10px; width:24px;cursor: pointer;"><svg t="1792234811368" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5642" width="24" height="24"><path d="M473.6 460.8l-81.066667 25.6c-4.266667-12.8-8.533333-25.6-8.533333-38.4C384 388.266667 430.933333 341.333333 490.666667 341.333333h42.666666c59.733333 0 106.666667 46.933333 106.666667 106.666667 0 51.2-38.4 93.866667-85.333333 102.4v4.266667h-85.333334v-85.333334h64c12.8 0 21.333333-8.533333 21.333334-21.333333s-8.533333-21.333333-21.333334-21.333333h-42.666666c-12.8 0-21.333333 8.533333-21.333334 21.333333 0 4.266667 0 8.533333 4.266667 12.8zM512 853.333333c-187.733333 0-341.333333-153.6-341.333333-341.333333s153.6-341.333333 341.333333-341.333333 341.333333 153.6 341.333333 341.333333-153.6 341.333333-341.333333 341.333333z m0-85.333333c140.8 0 256-115.2 256-256s-115.2-256-256-256-256 115.2-256 256 115.2 256 256 256z m-42.666667-170.666667h85.333334v85.333334h-85.333334v-85.333334z" fill="#1296db" p-id="5643"></path></svg></a></td>
                  <td class="plan-feature">{{current_version_setting.imageEditor?'✓':'✗'}}</td>                  
   <td class="feature-name">知识库目录</td>
                  <td class="plan-feature">{{current_version_setting.kbworkspaceFolder?'✓':'✗'}}</td>                   
                </tr>          
                           <tr>
                  <td class="feature-name">知识审核流程知识审核流程<a title="该权限用于定义租户编辑、发布知识库文档的工作是由系统管理员独立完成，还是由多个角色组成的团队配合完成。" style="margin-left: 10px; width:24px;cursor: pointer;"><svg t="1792234811368" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5642" width="24" height="24"><path d="M473.6 460.8l-81.066667 25.6c-4.266667-12.8-8.533333-25.6-8.533333-38.4C384 388.266667 430.933333 341.333333 490.666667 341.333333h42.666666c59.733333 0 106.666667 46.933333 106.666667 106.666667 0 51.2-38.4 93.866667-85.333333 102.4v4.266667h-85.333334v-85.333334h64c12.8 0 21.333333-8.533333 21.333334-21.333333s-8.533333-21.333333-21.333334-21.333333h-42.666666c-12.8 0-21.333333 8.533333-21.333334 21.333333 0 4.266667 0 8.533333 4.266667 12.8zM512 853.333333c-187.733333 0-341.333333-153.6-341.333333-341.333333s153.6-341.333333 341.333333-341.333333 341.333333 153.6 341.333333 341.333333-153.6 341.333333-341.333333 341.333333z m0-85.333333c140.8 0 256-115.2 256-256s-115.2-256-256-256-256 115.2-256 256 115.2 256 256 256z m-42.666667-170.666667h85.333334v85.333334h-85.333334v-85.333334z" fill="#1296db" p-id="5643"></path></svg></a></td>
                  <td class="plan-feature">
                      {{current_version_setting.verify_flow?'✓':'✗'}}                   
                  </td>
   <td class="feature-name">部署环境<a title="知识库的部署配置会直接影响AI客服的响应速度" style="margin-left: 10px; width:24px;cursor: pointer;"><svg t="1792234811368" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5642" width="24" height="24"><path d="M473.6 460.8l-81.066667 25.6c-4.266667-12.8-8.533333-25.6-8.533333-38.4C384 388.266667 430.933333 341.333333 490.666667 341.333333h42.666666c59.733333 0 106.666667 46.933333 106.666667 106.666667 0 51.2-38.4 93.866667-85.333333 102.4v4.266667h-85.333334v-85.333334h64c12.8 0 21.333333-8.533333 21.333334-21.333333s-8.533333-21.333333-21.333334-21.333333h-42.666666c-12.8 0-21.333333 8.533333-21.333334 21.333333 0 4.266667 0 8.533333 4.266667 12.8zM512 853.333333c-187.733333 0-341.333333-153.6-341.333333-341.333333s153.6-341.333333 341.333333-341.333333 341.333333 153.6 341.333333 341.333333-153.6 341.333333-341.333333 341.333333z m0-85.333333c140.8 0 256-115.2 256-256s-115.2-256-256-256-256 115.2-256 256 115.2 256 256 256z m-42.666667-170.666667h85.333334v85.333334h-85.333334v-85.333334z" fill="#1296db" p-id="5643"></path></svg></a></td>
                  <td class="plan-feature">
<a>{{current_version_setting.versionName=='试用版'?'低配共享资源池': (current_version_setting.versionName=='基础版'?'中配共享资源池':(current_version_setting.versionName=='团队版'?'高配共享资源池':(current_version_setting.versionName=='企业版'?'专有服务器':'-')))}}</a>                  
                  </td>    
 <td class="feature-name">AI 分析对话数（情感分析+意图分析）<a title="情感分析+意图分析的结果会体现在统计报表中。租户可以据此完善知识库内容，优化AI客服的表现" style="margin-left: 10px; width:24px;cursor: pointer;"><svg t="1792234811368" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5642" width="24" height="24"><path d="M473.6 460.8l-81.066667 25.6c-4.266667-12.8-8.533333-25.6-8.533333-38.4C384 388.266667 430.933333 341.333333 490.666667 341.333333h42.666666c59.733333 0 106.666667 46.933333 106.666667 106.666667 0 51.2-38.4 93.866667-85.333333 102.4v4.266667h-85.333334v-85.333334h64c12.8 0 21.333333-8.533333 21.333334-21.333333s-8.533333-21.333333-21.333334-21.333333h-42.666666c-12.8 0-21.333333 8.533333-21.333334 21.333333 0 4.266667 0 8.533333 4.266667 12.8zM512 853.333333c-187.733333 0-341.333333-153.6-341.333333-341.333333s153.6-341.333333 341.333333-341.333333 341.333333 153.6 341.333333 341.333333-153.6 341.333333-341.333333 341.333333z m0-85.333333c140.8 0 256-115.2 256-256s-115.2-256-256-256-256 115.2-256 256 115.2 256 256 256z m-42.666667-170.666667h85.333334v85.333334h-85.333334v-85.333334z" fill="#1296db" p-id="5643"></path></svg></a></td>
                  <td class="plan-feature" colspan="3">{{current_version_setting.ai_analysis_count_monthly>0?'前'+current_version_setting.ai_analysis_count_monthly+'条/月':'全部对话'}}</td>                                   
               </tr>   
               <tr>
                 <td class="feature-name">可感知服务水平</td>
                  <td class="plan-feature">
<a>{{current_version_setting.versionName=='试用版'?'标准响应': (current_version_setting.versionName=='基础版'?'标准响应':(current_version_setting.versionName=='团队版'?'优先响应（95%的请求响应时间小于2s）':(current_version_setting.versionName=='企业版'?'专有专有资源  + 升级窗口可控 + 数据物理隔离':'-')))}}</a>                  
                  </td>    
   
                <td class="feature-name">团队管理角色<a title="【企业管理员】负责本企业（实体）的整体规划、权限分配、人员管理、知识库配置和内容审核发布。注册平台用户时，提交的联系人就是企业管理员用户，联系人手机号就是管理员用户的用户名。企业管理员可以为员工用户分配不同的角色，每个角色都有自己的职责：
     【知识库管理员】：企业管理员可以执行管理知识库的创建、配置、上传文档、发布AI客服中心和部署AI客服席位等所有功能，也可以创建团队分担自己的工作。企业管理员可以为员工用户分配知识库，由员工用户负责管理和维护。分配了知识库的员工用户就是知识库管理员。
【内容编辑】： 负责知识库内容的撰写、编辑、分类、等日常运营工作。内容编辑可以编辑问答对文档，也可以通过平台提供的图文编辑器编写图文文档。
【内容审阅者】：对内容编辑提交的知识库文档进行审阅，对内容的准确性和实用性负责。通过审核的文档可以发布至知识库。
【企业管理者】：可以为AI客服运营经理和企业领导分配管理者角色，管理者角色可以查看所有用户的操作日志、以及AI客服自动解决率、未命中率、用户反馈等统计报表和与统计图表。管理者角色可以为内容编辑分配任务，从而驱动优化知识库的工作流。" style="margin-left: 10px; width:24px;cursor: pointer;"><svg t="1792234811368" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5642" width="24" height="24"><path d="M473.6 460.8l-81.066667 25.6c-4.266667-12.8-8.533333-25.6-8.533333-38.4C384 388.266667 430.933333 341.333333 490.666667 341.333333h42.666666c59.733333 0 106.666667 46.933333 106.666667 106.666667 0 51.2-38.4 93.866667-85.333333 102.4v4.266667h-85.333334v-85.333334h64c12.8 0 21.333333-8.533333 21.333334-21.333333s-8.533333-21.333333-21.333334-21.333333h-42.666666c-12.8 0-21.333333 8.533333-21.333334 21.333333 0 4.266667 0 8.533333 4.266667 12.8zM512 853.333333c-187.733333 0-341.333333-153.6-341.333333-341.333333s153.6-341.333333 341.333333-341.333333 341.333333 153.6 341.333333 341.333333-153.6 341.333333-341.333333 341.333333z m0-85.333333c140.8 0 256-115.2 256-256s-115.2-256-256-256-256 115.2-256 256 115.2 256 256 256z m-42.666667-170.666667h85.333334v85.333334h-85.333334v-85.333334z" fill="#1296db" p-id="5643"></path></svg></a></td>
                <td class="plan-feature" colspan="5">
                 <a v-if="current_version_setting.employeesManagement==0">只有系统管理员</a>
                 <a v-if="current_version_setting.employeesManagement==1">系统管理员+知识库管理员</a>                 
                 <a v-if="current_version_setting.employeesManagement==2">系统管理员+知识库管理员+企业管理者</a>                 
                 <a v-if="current_version_setting.employeesManagement==3">系统管理员+知识库管理员+内容编辑+内容审阅者+企业管理者</a>
                </td>                  
                </tr>                                                                
              </tbody>
            </table>
          </div>            
        <div slot="footer" class="dialog-footer">
 <input class="checkbox" type="checkbox" v-model="renew1year_after_upgrade"/><a class="checkbox-label">升级配置后，续费一年</a>
                  
          
            <el-button
              type="text"
              style="margin-right: 10px;"
              @click="goToCart_plan">

              <svg t="1765539348895" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5888" width="16" height="16"><path d="M919.68 704H292.48l-160-576H28.8V64h152.32l160 576h525.12l52.16-288H412.8V288h582.4l-75.52 416zM380.8 960a96 96 0 1 1 96-96 96 96 0 0 1-96 96z m0-128a32 32 0 1 0 32 32 32 32 0 0 0-32-32zM796.8 960a96 96 0 1 1 96-96 96 96 0 0 1-96 96z m0-128a32 32 0 1 0 32 32 32 32 0 0 0-32-32z" fill="#1296db" p-id="5889"></path><path d="M476.8 416h64v160h-64zM668.8 416h64v160h-64z" fill="#1296db" p-id="5890"></path></svg>
              去购物车结算
            </el-button>
            <el-button type="primary" @click="addPlanToCart(current_version_setting, renew1year_after_upgrade==0?3:4)"><!--1-套餐（新购），2-套餐（续费），3-套餐（升级配置）-->                
                 加入购物车
              </el-button>          
          <el-button type="plain" @click="cancel_upgrade">取 消</el-button>
        </div>
      </el-dialog>      

    <!-- 续费对话框--> 
      <el-dialog title="套餐续费(到期后续费1年)" :visible.sync="open_renew" width="560px" append-to-body>       
            <div class="plan-item">
            <a class="label">当前套餐：</a>
            <span class="value">{{ tenantInfo.versionName }}</span>
            </div>    
            <div class="plan-item">
              <span class="label">起止时间：</span>
              <span class="value"  v-if="tenantInfo && tenantInfo.versionStartDate && tenantInfo.versionEndDate">
                {{ tenantInfo.versionStartDate}}
                ~ 
                {{ tenantInfo.versionEndDate}}</span>
            </div>

            <div class="plan-item">
              <span class="label">有效期剩余天数：</span>
              <span class="value"  v-if="tenantInfo && tenantInfo.versionStartDate && tenantInfo.versionEndDate">
                {{ tenantInfo.validDaysLeft}}天</span>
            </div>                      
        <div slot="footer" class="dialog-footer">          
            <el-button
              type="text"
              style="margin-right: 10px;"
              @click="goToCart_plan">

              <svg t="1765539348895" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5888" width="16" height="16"><path d="M919.68 704H292.48l-160-576H28.8V64h152.32l160 576h525.12l52.16-288H412.8V288h582.4l-75.52 416zM380.8 960a96 96 0 1 1 96-96 96 96 0 0 1-96 96z m0-128a32 32 0 1 0 32 32 32 32 0 0 0-32-32zM796.8 960a96 96 0 1 1 96-96 96 96 0 0 1-96 96z m0-128a32 32 0 1 0 32 32 32 32 0 0 0-32-32z" fill="#1296db" p-id="5889"></path><path d="M476.8 416h64v160h-64zM668.8 416h64v160h-64z" fill="#1296db" p-id="5890"></path></svg>
              去购物车结算
            </el-button>
            <el-button type="primary" @click="addPlanToCart(current_version_setting, 2)"><!--1-套餐（新购），2-套餐（续费），3-套餐（升级配置）-->                
                 加入购物车
              </el-button>          
          <el-button type="plain" @click="cancel_renew">取 消</el-button>
        </div>
      </el-dialog>           
    </div>

  <el-dialog
    :title="'套餐【'+ tenantInfo.versionName+'】消费消息明细'"
    :visible.sync="dialogVisible_version"
    width="1200px"
    append-to-body 
    :close-on-click-modal="false"
    @close="handleClose_version"
  >
    <!-- 筛选条件栏 -->
    <div class="filter-bar">
     <!--a>套餐名称：</a>
     <a>{{  tenantInfo.versionName }}</a  -->

      <el-input
        v-model="keyword"
        placeholder="搜索问题/回答关键词"
        size="small"
        clearable
        style="width: 220px; margin-left: 12px;"

      >
        <i slot="prefix"><svg t="1783174517527" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1669" width="32" height="32"><path d="M868.629499 838.278052L683.630205 653.278758c46.972477-54.921665 72.265349-124.296401 72.265349-197.284404 0-168.378264-137.304164-305.682428-305.682428-305.682427C281.834862 150.311927 144.530699 287.61609 144.530699 455.994354c0 168.378264 137.304164 305.682428 305.682427 305.682428 44.804517 0 88.163726-9.394495 129.354976-28.90614 13.007763-5.781228 18.066337-20.956951 12.285109-33.964714C585.34933 686.520819 570.89626 680.739591 557.888497 686.520819c-33.964714 15.898377-70.097389 23.847565-107.675371 23.847565C310.018349 710.368384 195.116443 596.189132 195.116443 455.271701c0-140.194778 114.179252-255.096683 255.096683-255.096683 140.194778 0 255.096683 114.179252 255.096683 255.096683 0 67.929428-26.738179 132.245589-74.433309 179.94072-10.117149 10.117149-10.117149 26.015526 0 36.132674l202.342978 202.342978c5.058574 5.058574 11.562456 7.226535 18.066337 7.226535s13.007763-2.16796 18.066337-7.226535c8.671842-9.394495 8.671842-26.015526-0.722653-35.410021z" fill="#cdcdcd" p-id="1670"></path><path d="M286.893437 376.50247m-27.460833 0a27.460833 27.460833 0 1 0 54.921666 0 27.460833 27.460833 0 1 0-54.921666 0Z" fill="#cdcdcd" p-id="1671"></path><path d="M268.104446 473.338038m-27.460833 0a27.460833 27.460833 0 1 0 54.921666 0 27.460833 27.460833 0 1 0-54.921666 0Z" fill="#cdcdcd" p-id="1672"></path><path d="M311.463656 554.997883m-27.460833 0a27.460833 27.460833 0 1 0 54.921665 0 27.460833 27.460833 0 1 0-54.921665 0Z" fill="#cdcdcd" p-id="1673"></path></svg></i>
      </el-input>
      
      <el-button type="primary" size="small" @click="onSearch_version" style="margin-left: 12px;">
        <i><svg t="1783174517527" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1669" width="16" height="16"><path d="M868.629499 838.278052L683.630205 653.278758c46.972477-54.921665 72.265349-124.296401 72.265349-197.284404 0-168.378264-137.304164-305.682428-305.682428-305.682427C281.834862 150.311927 144.530699 287.61609 144.530699 455.994354c0 168.378264 137.304164 305.682428 305.682427 305.682428 44.804517 0 88.163726-9.394495 129.354976-28.90614 13.007763-5.781228 18.066337-20.956951 12.285109-33.964714C585.34933 686.520819 570.89626 680.739591 557.888497 686.520819c-33.964714 15.898377-70.097389 23.847565-107.675371 23.847565C310.018349 710.368384 195.116443 596.189132 195.116443 455.271701c0-140.194778 114.179252-255.096683 255.096683-255.096683 140.194778 0 255.096683 114.179252 255.096683 255.096683 0 67.929428-26.738179 132.245589-74.433309 179.94072-10.117149 10.117149-10.117149 26.015526 0 36.132674l202.342978 202.342978c5.058574 5.058574 11.562456 7.226535 18.066337 7.226535s13.007763-2.16796 18.066337-7.226535c8.671842-9.394495 8.671842-26.015526-0.722653-35.410021z" fill="#cdcdcd" p-id="1670"></path><path d="M286.893437 376.50247m-27.460833 0a27.460833 27.460833 0 1 0 54.921666 0 27.460833 27.460833 0 1 0-54.921666 0Z" fill="#cdcdcd" p-id="1671"></path><path d="M268.104446 473.338038m-27.460833 0a27.460833 27.460833 0 1 0 54.921666 0 27.460833 27.460833 0 1 0-54.921666 0Z" fill="#cdcdcd" p-id="1672"></path><path d="M311.463656 554.997883m-27.460833 0a27.460833 27.460833 0 1 0 54.921665 0 27.460833 27.460833 0 1 0-54.921665 0Z" fill="#cdcdcd" p-id="1673"></path></svg></i> 
        查询
      </el-button> 
      
      <span style="margin-left: 16px; color: #909399; font-size: 13px;">
        共 {{ total }} 条记录
      </span>
    </div>
    
    <!-- 套餐消费消息表格 -->
<el-table
  ref="feedbackTable"
  :data="filteredData_version"
  v-loading="loading"
  border
  stripe
  style="width: 100%; margin-top: 12px;"
  max-height="500"
>
  <el-table-column type="index" label="序号" width="60" align="center" />  
  <!-- 用户提问列（手动 tooltip） -->
  <el-table-column label="用户留言" width="350" min-width="180">
    <template slot-scope="{ row }">
      <el-tooltip
        :content=" row.user_message.includes('【系统提示】')?'-': row.user_message"
        placement="top"
        :disabled="!isOverflow"
        popper-class="custom-tooltip"
      >
        <span class="ellipsis-text">{{ row.user_message.includes("【系统提示】")?'-': row.user_message}}</span>
      </el-tooltip>
    </template>
  </el-table-column>

    <el-table-column prop="user_send_time" label="用户留言时间" width="150" align="center">
       <template slot-scope="{ row }">
          {{ formatDateTime(row.user_send_time)}}
        </template>
    </el-table-column>
  <!-- AI回复列（手动 tooltip） -->
<el-table-column label="AI回复" width="400" min-width="300">
  <template slot-scope="{ row }">
    <el-tooltip
      :content="row.ai_reply"
      placement="top"
      :disabled="!isOverflow" 
      popper-class="custom-tooltip"
    >
      <span class="ellipsis-text">{{ row.ai_reply }}</span>
    </el-tooltip>
  </template>
</el-table-column>
  

  
  <el-table-column prop="ai_reply_time" label="AI回复时间" width="150" align="center">  
           <template slot-scope="{ row }">
          {{ formatDateTime(row.ai_reply_time)}}
        </template>
  </el-table-column>
</el-table>
    
    <!-- 分页 -->
<div class="pagination-wrapper">

<el-pagination

@size-change="onSizeChange_version"

@current-change="onPageChange_version"

:current-page="pageNum_version + 1"

:page-sizes="[8, 10, 20, 50, 100]"

:page-size="pageSize"

layout="total, sizes, prev, pager, next, jumper"

:total="total"

/>

</div>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible_version = false">关 闭</el-button>
    </span>
  </el-dialog> 
  
  <el-dialog
    :title="'套餐【'+ tenantInfo.versionName+'】消费消息明细'"
    :visible.sync="dialogVisible_version"
    width="1200px"
    append-to-body 
    :close-on-click-modal="false"
    @close="handleClose_version"
  >
    <!-- 筛选条件栏 -->
    <div class="filter-bar">
     <!--a>套餐名称：</a>
     <a>{{  tenantInfo.versionName }}</a  -->

      <el-input
        v-model="keyword"
        placeholder="搜索问题/回答关键词"
        size="small"
        clearable
        style="width: 220px; margin-left: 12px;"

      >
        <i slot="prefix"><svg t="1783174517527" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1669" width="32" height="32"><path d="M868.629499 838.278052L683.630205 653.278758c46.972477-54.921665 72.265349-124.296401 72.265349-197.284404 0-168.378264-137.304164-305.682428-305.682428-305.682427C281.834862 150.311927 144.530699 287.61609 144.530699 455.994354c0 168.378264 137.304164 305.682428 305.682427 305.682428 44.804517 0 88.163726-9.394495 129.354976-28.90614 13.007763-5.781228 18.066337-20.956951 12.285109-33.964714C585.34933 686.520819 570.89626 680.739591 557.888497 686.520819c-33.964714 15.898377-70.097389 23.847565-107.675371 23.847565C310.018349 710.368384 195.116443 596.189132 195.116443 455.271701c0-140.194778 114.179252-255.096683 255.096683-255.096683 140.194778 0 255.096683 114.179252 255.096683 255.096683 0 67.929428-26.738179 132.245589-74.433309 179.94072-10.117149 10.117149-10.117149 26.015526 0 36.132674l202.342978 202.342978c5.058574 5.058574 11.562456 7.226535 18.066337 7.226535s13.007763-2.16796 18.066337-7.226535c8.671842-9.394495 8.671842-26.015526-0.722653-35.410021z" fill="#cdcdcd" p-id="1670"></path><path d="M286.893437 376.50247m-27.460833 0a27.460833 27.460833 0 1 0 54.921666 0 27.460833 27.460833 0 1 0-54.921666 0Z" fill="#cdcdcd" p-id="1671"></path><path d="M268.104446 473.338038m-27.460833 0a27.460833 27.460833 0 1 0 54.921666 0 27.460833 27.460833 0 1 0-54.921666 0Z" fill="#cdcdcd" p-id="1672"></path><path d="M311.463656 554.997883m-27.460833 0a27.460833 27.460833 0 1 0 54.921665 0 27.460833 27.460833 0 1 0-54.921665 0Z" fill="#cdcdcd" p-id="1673"></path></svg></i>
      </el-input>
      
      <el-button type="primary" size="small" @click="onSearch_version" style="margin-left: 12px;">
        <i><svg t="1783174517527" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1669" width="16" height="16"><path d="M868.629499 838.278052L683.630205 653.278758c46.972477-54.921665 72.265349-124.296401 72.265349-197.284404 0-168.378264-137.304164-305.682428-305.682428-305.682427C281.834862 150.311927 144.530699 287.61609 144.530699 455.994354c0 168.378264 137.304164 305.682428 305.682427 305.682428 44.804517 0 88.163726-9.394495 129.354976-28.90614 13.007763-5.781228 18.066337-20.956951 12.285109-33.964714C585.34933 686.520819 570.89626 680.739591 557.888497 686.520819c-33.964714 15.898377-70.097389 23.847565-107.675371 23.847565C310.018349 710.368384 195.116443 596.189132 195.116443 455.271701c0-140.194778 114.179252-255.096683 255.096683-255.096683 140.194778 0 255.096683 114.179252 255.096683 255.096683 0 67.929428-26.738179 132.245589-74.433309 179.94072-10.117149 10.117149-10.117149 26.015526 0 36.132674l202.342978 202.342978c5.058574 5.058574 11.562456 7.226535 18.066337 7.226535s13.007763-2.16796 18.066337-7.226535c8.671842-9.394495 8.671842-26.015526-0.722653-35.410021z" fill="#cdcdcd" p-id="1670"></path><path d="M286.893437 376.50247m-27.460833 0a27.460833 27.460833 0 1 0 54.921666 0 27.460833 27.460833 0 1 0-54.921666 0Z" fill="#cdcdcd" p-id="1671"></path><path d="M268.104446 473.338038m-27.460833 0a27.460833 27.460833 0 1 0 54.921666 0 27.460833 27.460833 0 1 0-54.921666 0Z" fill="#cdcdcd" p-id="1672"></path><path d="M311.463656 554.997883m-27.460833 0a27.460833 27.460833 0 1 0 54.921665 0 27.460833 27.460833 0 1 0-54.921665 0Z" fill="#cdcdcd" p-id="1673"></path></svg></i> 
        查询
      </el-button> 
      
      <span style="margin-left: 16px; color: #909399; font-size: 13px;">
        共 {{ total }} 条记录
      </span>
    </div>
    
    <!-- 表格 -->
<el-table
  ref="feedbackTable"
  :data="filteredData_version"
  v-loading="loading"
  border
  stripe
  style="width: 100%; margin-top: 12px;"
  max-height="500"
>
  <el-table-column type="index" label="序号" width="60" align="center" />  
  <!-- 用户提问列（手动 tooltip） -->
  <el-table-column label="用户留言" width="350" min-width="180">
    <template slot-scope="{ row }">
      <el-tooltip
        :content=" row.user_message.includes('【系统提示】')?'-': row.user_message"
        placement="top"
        :disabled="!isOverflow"
        popper-class="custom-tooltip"
      >
        <span class="ellipsis-text">{{ row.user_message.includes("【系统提示】")?'-': row.user_message}}</span>
      </el-tooltip>
    </template>
  </el-table-column>

    <el-table-column prop="user_send_time" label="用户留言时间" width="150" align="center">
       <template slot-scope="{ row }">
          {{ formatDateTime(row.user_send_time)}}
        </template>
    </el-table-column>
  <!-- AI回复列（手动 tooltip） -->
<el-table-column label="AI回复" width="400" min-width="300">
  <template slot-scope="{ row }">
    <el-tooltip
      :content="row.ai_reply"
      placement="top"
      :disabled="!isOverflow" 
      popper-class="custom-tooltip"
    >
      <span class="ellipsis-text">{{ row.ai_reply }}</span>
    </el-tooltip>
  </template>
</el-table-column>
  

  
  <el-table-column prop="ai_reply_time" label="AI回复时间" width="150" align="center">  
           <template slot-scope="{ row }">
          {{ formatDateTime(row.ai_reply_time)}}
        </template>
  </el-table-column>
</el-table>
    
    <!-- 分页 -->
<div class="pagination-wrapper">

<el-pagination

@size-change="onSizeChange_version"

@current-change="onPageChange_version"

:current-page="pageNum_version + 1"

:page-sizes="[8, 10, 20, 50, 100]"

:page-size="pageSize"

layout="total, sizes, prev, pager, next, jumper"

:total="total"

/>

</div>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible_version = false">关 闭</el-button>
    </span>
  </el-dialog>   

  <el-dialog
    :title="'加油包【'+ currentPackageame+'】消费消息明细'"
    :visible.sync="dialogVisible_fuel"
    width="1200px"
    append-to-body 
    :close-on-click-modal="false"
    @close="handleClose_fuel"
  >
    <!-- 筛选条件栏 -->
    <div class="filter-bar">
     <!--a>套餐名称：</a>
     <a>{{  tenantInfo.versionName }}</a  -->

      <el-input
        v-model="keyword"
        placeholder="搜索问题/回答关键词"
        size="small"
        clearable
        style="width: 220px; margin-left: 12px;"

      >
        <i slot="prefix"><svg t="1783174517527" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1669" width="32" height="32"><path d="M868.629499 838.278052L683.630205 653.278758c46.972477-54.921665 72.265349-124.296401 72.265349-197.284404 0-168.378264-137.304164-305.682428-305.682428-305.682427C281.834862 150.311927 144.530699 287.61609 144.530699 455.994354c0 168.378264 137.304164 305.682428 305.682427 305.682428 44.804517 0 88.163726-9.394495 129.354976-28.90614 13.007763-5.781228 18.066337-20.956951 12.285109-33.964714C585.34933 686.520819 570.89626 680.739591 557.888497 686.520819c-33.964714 15.898377-70.097389 23.847565-107.675371 23.847565C310.018349 710.368384 195.116443 596.189132 195.116443 455.271701c0-140.194778 114.179252-255.096683 255.096683-255.096683 140.194778 0 255.096683 114.179252 255.096683 255.096683 0 67.929428-26.738179 132.245589-74.433309 179.94072-10.117149 10.117149-10.117149 26.015526 0 36.132674l202.342978 202.342978c5.058574 5.058574 11.562456 7.226535 18.066337 7.226535s13.007763-2.16796 18.066337-7.226535c8.671842-9.394495 8.671842-26.015526-0.722653-35.410021z" fill="#cdcdcd" p-id="1670"></path><path d="M286.893437 376.50247m-27.460833 0a27.460833 27.460833 0 1 0 54.921666 0 27.460833 27.460833 0 1 0-54.921666 0Z" fill="#cdcdcd" p-id="1671"></path><path d="M268.104446 473.338038m-27.460833 0a27.460833 27.460833 0 1 0 54.921666 0 27.460833 27.460833 0 1 0-54.921666 0Z" fill="#cdcdcd" p-id="1672"></path><path d="M311.463656 554.997883m-27.460833 0a27.460833 27.460833 0 1 0 54.921665 0 27.460833 27.460833 0 1 0-54.921665 0Z" fill="#cdcdcd" p-id="1673"></path></svg></i>
      </el-input>
      
      <el-button type="primary" size="small" @click="onSearch_fuel" style="margin-left: 12px;">
        <i><svg t="1783174517527" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1669" width="16" height="16"><path d="M868.629499 838.278052L683.630205 653.278758c46.972477-54.921665 72.265349-124.296401 72.265349-197.284404 0-168.378264-137.304164-305.682428-305.682428-305.682427C281.834862 150.311927 144.530699 287.61609 144.530699 455.994354c0 168.378264 137.304164 305.682428 305.682427 305.682428 44.804517 0 88.163726-9.394495 129.354976-28.90614 13.007763-5.781228 18.066337-20.956951 12.285109-33.964714C585.34933 686.520819 570.89626 680.739591 557.888497 686.520819c-33.964714 15.898377-70.097389 23.847565-107.675371 23.847565C310.018349 710.368384 195.116443 596.189132 195.116443 455.271701c0-140.194778 114.179252-255.096683 255.096683-255.096683 140.194778 0 255.096683 114.179252 255.096683 255.096683 0 67.929428-26.738179 132.245589-74.433309 179.94072-10.117149 10.117149-10.117149 26.015526 0 36.132674l202.342978 202.342978c5.058574 5.058574 11.562456 7.226535 18.066337 7.226535s13.007763-2.16796 18.066337-7.226535c8.671842-9.394495 8.671842-26.015526-0.722653-35.410021z" fill="#cdcdcd" p-id="1670"></path><path d="M286.893437 376.50247m-27.460833 0a27.460833 27.460833 0 1 0 54.921666 0 27.460833 27.460833 0 1 0-54.921666 0Z" fill="#cdcdcd" p-id="1671"></path><path d="M268.104446 473.338038m-27.460833 0a27.460833 27.460833 0 1 0 54.921666 0 27.460833 27.460833 0 1 0-54.921666 0Z" fill="#cdcdcd" p-id="1672"></path><path d="M311.463656 554.997883m-27.460833 0a27.460833 27.460833 0 1 0 54.921665 0 27.460833 27.460833 0 1 0-54.921665 0Z" fill="#cdcdcd" p-id="1673"></path></svg></i> 
        查询
      </el-button> 
      
      <span style="margin-left: 16px; color: #909399; font-size: 13px;">
        共 {{ total }} 条记录
      </span>
    </div>
    
    <!-- 表格 -->
<el-table
  ref="feedbackTable"
  :data="filteredData_fuel"
  v-loading="loading"
  border
  stripe
  style="width: 100%; margin-top: 12px;"
  max-height="500"
>
  <el-table-column type="index" label="序号" width="60" align="center" />  
  <!-- 用户提问列（手动 tooltip） -->
  <el-table-column label="用户留言" width="350" min-width="180">
    <template slot-scope="{ row }">
      <el-tooltip
        :content=" row.user_message.includes('【系统提示】')?'-': row.user_message"
        placement="top"
        :disabled="!isOverflow"
        popper-class="custom-tooltip"
      >
        <span class="ellipsis-text">{{ row.user_message.includes("【系统提示】")?'-': row.user_message}}</span>
      </el-tooltip>
    </template>
  </el-table-column>

    <el-table-column prop="user_send_time" label="用户留言时间" width="150" align="center">
       <template slot-scope="{ row }">
          {{ formatDateTime(row.user_send_time)}}
        </template>
    </el-table-column>
  <!-- AI回复列（手动 tooltip） -->
<el-table-column label="AI回复" width="400" min-width="300">
  <template slot-scope="{ row }">
    <el-tooltip
      :content="row.ai_reply"
      placement="top"
      :disabled="!isOverflow" 
      popper-class="custom-tooltip"
    >
      <span class="ellipsis-text">{{ row.ai_reply }}</span>
    </el-tooltip>
  </template>
</el-table-column>
  

  
  <el-table-column prop="ai_reply_time" label="AI回复时间" width="150" align="center">  
           <template slot-scope="{ row }">
          {{ formatDateTime(row.ai_reply_time)}}
        </template>
  </el-table-column>
</el-table>
    
    <!-- 分页 -->
<div class="pagination-wrapper">

<el-pagination

@size-change="onSizeChange_fuel"

@current-change="onPageChange_fuel"

:current-page="pageNum_fuel + 1"

:page-sizes="[8, 10, 20, 50, 100]"

:page-size="pageSize"

layout="total, sizes, prev, pager, next, jumper"

:total="total"

/>

</div>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible_fuel = false">关 闭</el-button>
    </span>
  </el-dialog>    
  </div>  
</template>

<script>
import { getFeedbackDetail } from '@/api/dashboard'
import { load_version_settings,load_fuel_package, load_my_fuel_package, countConsumedMessagesbyVersion } from '@/api/tenant/plan'
import { getFuelPackages, addToCart, getCartItems, updateCartItem, 
        removeCartItem, clearCart } from '@/api/tenant/cart'
import {loadConversationsByversionNameAndTenantId, loadConversationsByPackageNameAndTenantId} from '@/api/tenant/conversation'
import { formatToBeijingTime } from '@/util/date';
//import axios from 'axios';
//import { version } from 'vue/types/umd';


export default {
  name: "PlanAndPackage",
  data() {
    return {    
      //套餐相关
      version_settings: [],
      my_fuel_packages: [],
      current_version_setting: null,
      current_fuel_package:null,
      remainingConversations: 0,
      costConversations: 0,
      // 消费对话记录对话框相关变量
      dialogVisible_version: false,  
      dialogVisible_fuel: false,
      tableData_version: [],
          tableData_fuel: [],
      total: 0,
      pageNum_version: 0,
      pageSize: 8,
      // 加油包相关
       pageNum_fuel: 0,
      fuelPackages: [],
      selectedFuelPackageId: null, 
      currentPackageame: '',     
      // 购物车相关
      cartItems: [],
      cartTotal: 0,
      loading: false, // 新增loading状态

      open_plan: false, // 选择套餐弹窗状态
      open_fuel: false, // 选择流量包弹窗状态
      open_upgrade: false, // 选择套餐升级配置弹窗状态
      open_renew: false, // 选择套餐续费弹窗状态

      versionCode_selected: '', // 选择的套餐编码
      pkgCodeSelected:'', //选择流量包编码
      renew1year_after_upgrade: 0,//升级配置后续费1年
      tab_class_1: 'tab-active',
      tab_class_2: 'tab',
      show_plan_details: false,
      keyword: ''

    }
  },
  computed: {
    tenantInfo() {
      return this.$store.getters['auth/currentTenant'];
    },
    tenantId() {
      return this.tenantInfo?.tenantId || null;
    },
    filteredData_version() {
      return this.tableData_version.map(item => ({
        ...item,
        ai_reply: item.ai_reply.replace(/<think>[\s\S]*?<\/think>/g, '')
      }));
   },
       filteredData_fuel() {
      return this.tableData_fuel.map(item => ({
        ...item,
        ai_reply: item.ai_reply.replace(/<think>[\s\S]*?<\/think>/g, '')
      }));
   }
  },
  async mounted() {
  console.log("tenantInfo",this.tenantInfo);
  if(this.tenantInfo && this.tenantInfo.status && this.tenantInfo.status.trim()!=='APPROVED'){
      this.$message.error('租户状态未激活');  
      this.logout();
  }     

        load_version_settings().then(response=>{
      console.log("load_version_settings:", response);
      this.version_settings = response.data.data;
       console.log(this.version_settings);
    })  
    
     let response = await load_my_fuel_package(this.tenantId);
      console.log("load_my_fuel_package",response);
      if(response.data.code==200){
        this.my_fuel_packages = response.data.data;
        console.log(" this.my_fuel_packages",  this.my_fuel_packages)
      }

      let response_use_messages = await countConsumedMessagesbyVersion(this.tenantId, this.tenantInfo.versionName)
      console.log("countConsumedMessagesbyVersion", response_use_messages);
      if(response_use_messages.code == 200){
        this.costConversations = response_use_messages.data;
        //alert(this.costConversations)
         this.remainingConversations = this.tenantInfo.monthlyConversationCount-Number(response_use_messages.data);
         console.log("this.remainingConversations", this.remainingConversations)
      }
  },
  methods: {
    formatDateTime(time) {
      if (!time) return '-'
         return formatToBeijingTime(time)
    }, 
    // 切换每页条数
    onSizeChange_version(newSize) {

    this.pageSize = newSize;

    this.pageNum_version = 0; // 改变条数后重置回第一页

    this.loadData_version(); // 重新请求数据

    },
        // 切换每页条数
    onSizeChange_fuel(newSize) {

    this.pageSize = newSize;

    this.pageNum_fuel = 0; // 改变条数后重置回第一页

    this.loadData_fuel(); // 重新请求数据

    },
    // 套餐消息切换页码
 onPageChange_version(newPage) {
    console.log("===== onPageChange_version 被触发 =====");
    console.log("点击的页码（1-based）:", newPage);
    console.log("当前 this.pageNum_fuel（0-based）:", this.pageNum_fuel);    
    // 更新页码
    this.pageNum_version = newPage - 1;
    console.log("更新后的 this.pageNum_fuel:", this.pageNum_fuel);    
    // 重新请求数据
    this.loadData_version();
  },    
    // 加油包消息切换页码
    
 onPageChange_fuel(newPage) {
    console.log("===== onPageChange_fuel被触发 =====");
    console.log("点击的页码（1-based）:", newPage);
    console.log("当前 this.pageNum_fuel（0-based）:", this.pageNum_fuel);    
    // 更新页码
    this.pageNum_fuel = newPage - 1;
    console.log("更新后的 this.pageNum_fuel:", this.pageNum_fuel);    
    // 重新请求数据
    this.loadData_fuel(this.currentPackageame, this.tenantId);
  },  
    isOverflow(el) {
      // 判断元素内容是否超出容器宽度
      return el && el.scrollWidth > el.clientWidth
    },        
    handleClose_version() {
      this.dialogVisible_version = false
    },
    handleClose_fuel() {
      this.dialogVisible_fuel = false
    },
    onSearch_version() {
      this.pageNum_version = 0
      alert(this.keyword)
      this.loadData_version()
    },
    onSearch_fuel() {
      this.pageNum_fuel = 0
      alert(this.keyword)
      this.loadData_fuel()
    },
   async loadData_version(){
      let versionName = this.tenantInfo.versionName;
      let tenantId = this.tenantInfo.tenantId;
      try {
        console.log("loadConversationsByversionNameAndTenantId，pageNum=", this.pageNum_version)
        const response = await loadConversationsByversionNameAndTenantId(
          versionName, 
          tenantId, 
          this.keyword,
          {
            pageNum: this.pageNum_version,
            pageSize: this.pageSize
          }
        );
        console.log("loadConversationsByversionNameAndTenantId", response)
        // 根据实际返回结构调整
        // 假设后端返回格式: { code: 200, data: { content: [...], totalElements: 100 } }
        if (response.data && response.data.code === 200) {
          this.tableData_version = response.data.data.content || [];
          this.total = response.data.data.total_elements || 0;
          console.log("this.tableData_version", this.tableData_version);
           console.log("this.total", this.total);
          console.log("数据加载成功，条数:", this.tableData_version.length);
        } else {
          this.tableData = [];
          this.$message.warning(response.data?.message || '数据加载异常');
        }
        
      } catch (error) {
        console.error("加载失败:", error);
        
        if (error.code === 'ECONNABORTED') {
          this.$message.error('请求超时，请稍后重试');
        } else if (error.response) {
          const status = error.response.status;
          const messages = {
            400: '请求参数错误',
            404: '接口不存在',
            500: '服务器内部错误',
            502: '网关错误',
            503: '服务不可用'
          };
          this.$message.error(messages[status] || `请求失败(${status})`);
        } else if (error.request) {
          this.$message.error('无法连接到服务器，请检查后端服务');
        } else {
          this.$message.error('发生未知错误');
        }
      }
    },
       async loadData_fuel( packageName, tenantId){
      try {
        const response = await loadConversationsByPackageNameAndTenantId(
          packageName, 
          tenantId, 
          this.keyword,
          {
            pageNum: this.pageNum_fuel,
            pageSize: this.pageSize
          }
        );
        console.log("loadConversationsByPackageNameAndTenantId", response)
        // 根据实际返回结构调整
        // 假设后端返回格式: { code: 200, data: { content: [...], totalElements: 100 } }
        if (response.data && response.data.code === 200) {
          this.tableData_fuel = response.data.data.content || [];
          console.log("this.tableData_fuel",this.tableData_fuel)
          this.total = response.data.data.total_elements || 0;
          console.log("this.tableData_fuel", this.tableData_fuel);
           console.log("this.total", this.total);
          console.log("数据加载成功，条数:", this.tableData_fuel.length);
        } else {
          this.tableData_fuel = [];
          this.$message.warning(response.data?.message || '数据加载异常');
        }
        
      } catch (error) {
        console.error("加载失败:", error);
        
        if (error.code === 'ECONNABORTED') {
          this.$message.error('请求超时，请稍后重试');
        } else if (error.response) {
          const status = error.response.status;
          const messages = {
            400: '请求参数错误',
            404: '接口不存在',
            500: '服务器内部错误',
            502: '网关错误',
            503: '服务不可用'
          };
          this.$message.error(messages[status] || `请求失败(${status})`);
        } else if (error.request) {
          this.$message.error('无法连接到服务器，请检查后端服务');
        } else {
          this.$message.error('发生未知错误');
        }
      }
    },
 async show_consume_details(/*versionName, tenantId*/) {
      //console.log("show_consume_details called with:", versionName, tenantId);
      this.dialogVisible_version = true;
      this.loadData_version();
    },
 async show_consume_details_fuel(packageName, tenantId) {
      //console.log("show_consume_details_fuel called with:", packageName, tenantId);
      this.dialogVisible_fuel = true;
      this.currentPackageame = packageName;
      this.loadData_fuel( packageName, tenantId);
    },
    async loadVersionConsumedConversations() {
      if (!this.tenantId) {
        this.$message.warning('请先登录')
        return
      }
//      alert(this.keyword)
      this.loading = true
      try {
        const params = {
          tenantId: this.tenantId,
          startTime: this.dateRange[0] + ' 00:00:00',
          endTime: this.dateRange[1] + ' 23:59:59',
          page: this.pageNum_fuel,
          size: this.pageSize,
          keyword: this.keyword || '',      // ← 传递关键词
          isHit: this.filterHit              // ← 传递命中筛选
        }
        
        const res = await getFeedbackDetail(params)
            console.log('反馈明细响应:', res)
            
            if (res?.data?.code === 200) {
              const data = res.data.data
              this.tableData = data?.content || []
              this.total = data?.total_elements || 0
              this.pageNum_version = data?.pageable?.page_number || 0
            } else {
              this.$message.error(res?.data?.message || '加载失败')
              this.tableData = []
              this.total = 0
            }
          } catch (error) {
            console.error('加载反馈明细失败:', error)
            this.$message.error('加载失败: ' + (error.message || '未知错误'))
            this.tableData = []
            this.total = 0
          } finally {
              this.$nextTick(() => {
                // 强制刷新表格的 tooltip 绑定
                this.$refs.feedbackTable?.doLayout()
              })
            this.loading = false
          }
    },    

    // 获取状态显示文本
    getStatusText(status) {
      const statusTextMap = {
        'active': '已启用',
        'disabled': '已禁用',

      };
      return statusTextMap[status] || status;
    },
    HandlePlanUpgrade(){
        if(this.tenantInfo.versionName == "企业版")
        {
          this.$message.error("您当前的套餐是【企业版】,不能再升级");
          return;
        }
        this.open_upgrade = true;
        this.reset_upgrade();
    },
    HandlePlanSelector() {
      this.open_plan = true
      this.reset_plan()
    },
    HandleRenew(){
      this.open_renew = true;
      this.reset_renew();
    },
    async HandleFuelpackageSelector(){
     let response = await getFuelPackages();
      console.log(response)
      if(response.data.code==200){
        this.fuelPackages = response.data.data;
      }
      this.open_fuel = true
      this.reset_fuel()
    },
   // 加载版本设置
    loadVersionSettings() {
      load_version_settings().then(response => {
        this.version_settings = response.data.data;
      }).catch(error => {
        console.error("加载版本设置失败:", error);
      });
    },
    
    // 加载加油包
    loadFuelPackages() {
      load_fuel_package().then(response => {
        this.fuelPackages = response.data.data;
      }).catch(error => {
        console.error("加载加油包失败:", error);
      });
    },
    
    // 加载购物车
    loadCartItems() {
      getCartItems().then(response => {
        this.cartItems = response.data.data;
        this.calculateTotal();
      }).catch(error => {
        console.error("加载购物车失败:", error);
      });
    },

    
    // 选择加油包
    selectFuelPackage(pkg) {
      this.selectedFuelPackageId = pkg.id;
    },
    
   // 1-套餐（新购），2-套餐（续费），3-套餐（升级配置），4-升级配置后续费1年，5-加油包
    addPlanToCart(plan, itemType) {
      console.log(plan, itemType)
            if(plan == null && itemType!=2){  //续费不用选择目标套餐
        this.$message.error("请选择套餐");
        return;
      }
      const cartItem = {
        tenant_id: this.tenantId,
        itemType: itemType, // 1-套餐，2续费，3-升级配置，4-升级配置后续费1年，5流量包
        newItemId: itemType==2?0:plan.id,
        itemName: itemType==2?'':plan.versionName,
        unitPrice: itemType==2?0:plan.monthlyPrice,
        quantity: 1
      };
      
      addToCart(cartItem).then(response => {
        console.log(response);
        if(response.data.code==200){
        this.$message.success('已添加到购物车，您可以去购物车结算');
        this.loadCartItems();
        this.open_plan = false;
        this.open_upgrade =false;
        this.open_renew = false;
        }
        else{
this.$message.error(response.data.message);
        }
      }).catch(error => {
        this.$message.error('添加失败'+error);
      });
    },
    // 添加加油包到购物车
    addFuelpackageToCart(fuelpackage) {
      console.log(fuelpackage)
            if(fuelpackage == null){
        this.$message.error("请选择流量包");
        return;
      }
      const cartItem = {
        itemType: 2, // 2-流量包
        itemId: fuelpackage.id,
        itemName: fuelpackage.package_name,
        unitPrice: fuelpackage.currentPrice,
        quantity: 1,
        tenant_id: this.tenantId
      };
      
      console.log("addFuelpackageToCart",cartItem)
      addToCart(cartItem).then(response => {
        console.log(response);
        this.$message.success('已添加到购物车');
        this.loadCartItems();
        this.open_fuel = false;
      }).catch(error => {
        this.$message.error('添加失败'+error);
      });
    },

    // 添加加油包到购物车
    addFuelToCart(pkg) {
      if(pkg == null || pkg == undefined){
           this.$message.error('请选择流量包');
           return;
      }
      const cartItem = {
        itemType: 5, // 5-加油包
        newItemId: pkg.id,
        itemName: pkg.package_name,
        unitPrice: pkg.current_price,
        quantity: 1,
        tenant_id: this.tenantId
      };

      console.log("addFuelToCart",cartItem);
      addToCart(cartItem).then(response => {
        console.log(response);
        if(response.data.code===200){
        this.$message.success('已添加到购物车');
        this.open_fuel = false;
        //this.loadCartItems();
        }
        else{
           this.$message.error(response.data.message);
        }
      }).catch(error => {
        this.$message.error('添加失败'+error);
      });
    },
    
    // 更新购物车项
    updateCartItem(item) {
      updateCartItem(item).then(response => {
        console.log(response);        
        this.calculateTotal();
        this.$message.success('已更新');
      }).catch(error => {
        this.$message.error('更新失败'+error);
      });
    },
    
    // 从购物车移除
    removeFromCart(id) {
      this.$confirm('确定要从购物车移除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeCartItem(id).then(response => {
          console.log(response);
          this.loadCartItems();
          this.$message.success('已移除');
        }).catch(error => {
          this.$message.error('移除失败'+error);
        });
      });
    },
    
    // 清空购物车
    clearCart() {
      this.$confirm('确定要清空购物车吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        clearCart().then(response => {
        console.log(response);          
          this.cartItems = [];
          this.cartTotal = 0;
          this.$message.success('购物车已清空');
        }).catch(error => {
          this.$message.error('清空失败'+error);
        });
      });
    },
    
    // 计算购物车总价
    calculateTotal() {
      this.cartTotal = this.cartItems.reduce((total, item) => {
        return total + (item.unitPrice * item.quantity);
      }, 0);
    },
    
    // 去结算
    goToCheckout() {
      if (this.cartItems.length === 0) {
        this.$message.warning('购物车为空');
        return;
      }
      
      // 跳转到结算页面
      this.$router.push('/order/checkout');
    },
    
    // 查看购物车
    goToCart_plan() {
      this.open_plan = false;
      this.open_upgrade = false
      this.$router.push(`/admin/cart`);

      
    },
    // 查看购物车
    goToCart_fuel() {
      this.open_fuel = false;
      // 如果购物车为空，显示提示
   /*   if (this.cartItems.length === 0) {
        this.$message.info('购物车为空，请先添加商品');
      }*/
      this.$router.push(`/admin/cart`);
    },    
    // 格式化日期
    formatDate(date) {
      if (!date) return '';
      return new Date(date).toLocaleDateString();
    },   
    reset_plan() {
      this.versionCode_selected = '';     
    },
    reset_fuel() {
      this.pkgCodeSelected = '';     
    },
    reset_upgrade() {
      this.versionCode_selected = '';     
    },

    /** 提交按钮 */
    submitForm: function () {
    
    },
    cancel_upgrade(){
      this.open_upgrade = false;
      this.reset_plan();
    },        
    cancel_renew(){
      this.open_renew = false;
    },
    // 取消按钮
    cancel_plan() {
      this.open_plan = false;
      this.reset_plan();
    },
    // 取消按钮
    cancel_fuel() {
      this.open_fuel = false;
      this.reset_fuel();
    },    
    HandleSelect_plan(versionCode){

      this.versionCode_selected = versionCode;
      for(let i=0;i<this.version_settings.length;i++){
        if(this.version_settings[i].versionCode === this.versionCode_selected){
          this.current_version_setting = this.version_settings[i];
          break;
        }       
      }
      console.log(this.current_version_setting);
    },
    HandleSelect_fuel(pkgCode){
          console.log(pkgCode);

      this.pkgCodeSelected = pkgCode;
      for(let i=0;i<this.fuelPackages.length;i++){
        if(this.fuelPackages[i].package_code === pkgCode){
          this.current_fuel_package = this.fuelPackages[i];
          break;
        }       
      }
      console.log(this.current_version_setting);
    },
    canUpgrade(targetVersionCode){
      console.log("canUpgrade1", targetVersionCode, this.tenantInfo.versionName)
      let current_versionCode = "";
      switch(this.tenantInfo.versionName){
        case "免费版":
          current_versionCode = "VERSION_TRIAL"
          break;
         case "基础版":
          current_versionCode = "VERSION_BASIC"
          break;       
         case "团队版":
          current_versionCode = "VERSION_GROUP"
          break;    
         case "企业版":
          current_versionCode = "VERSION_ENTERPRISE"
          break;                                     
      }

      console.log("canUpgrade:2,targetVersionCode,targetVersionCode:"+ targetVersionCode+"， current_versionCode:"+ current_versionCode);
      // 1.不能升级到免费版，2.企业版不能升级
      if(targetVersionCode == "VERSION_TRIAL"  || current_versionCode == "VERSION_ENTERPRISE"){
        console.log("return false 1")
        return false;
      }
      // 不能升级到自己
    if(targetVersionCode == current_versionCode){
      console.log("return false 2")
      return false;
    }
    if(current_versionCode ==="VERSION_GROUP" && targetVersionCode==="VERSION_PERSONAL"){
      console.log("return false 3")      
      return false;
    }
            console.log("return true")
        return true;

    },
    set_tab_active(no){
        if(no==1){
          this.tab_class_1="tab-active";
                    this.tab_class_2="tab";
        }else{
          this.tab_class_2="tab-active";          
          this.tab_class_1="tab";
        }
    },
    async logout() {
      try {
        // 调用 Vuex 中的 logout action
        await this.$store.dispatch('auth/logout')
        // 退出成功后跳转到登录页
        this.$router.push('/login')
      } catch (error) {
        console.error('退出登录失败:', error)
        // 即使退出API调用失败，也强制清除本地状态并跳转
        this.$store.commit('auth/CLEAR_AUTH')
        this.$router.push('/login')
      }
    }, 
    
  }
}
</script>

<style scoped>
/* 仪表盘样式 */
.dashboard-tab {
  padding: 0;
}

.tab-title {
  color: #333;
  margin-bottom: 25px;
  font-size: 1.5rem;
  font-weight: 500;
}

.info-section {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 15px;
}
.content{
    padding: 5px 5px 5px 5px;
}
.info-text {
  display: block;
  color: rgba(5, 127, 219, 0.6);;
  font-size: 0.9rem;
  margin: 10px auto 10px auto;
  width: 100%;
  text-align: center;
  
  
}

.button-group {
  display: flex;
  gap: 10px;
}

/* 表格样式优化 */
.custom-table {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.custom-table ::v-deep .custom-header th {
  background-color: #f5f7fa;
  color: #606266;
  font-weight: 600;
  padding: 12px 10px;
}

.custom-table ::v-deep .custom-row td {
  padding: 12px 10px;
  border-bottom: 1px solid #ebeef5;
}

.custom-table ::v-deep .custom-row:hover td {
  background-color: #f5f7fa;
}

/* 头像样式 */
.avatar-placeholder {
  font-weight: bold;
  color: #fff;
}

/* 文本样式 */
.name-text {
  font-weight: 500;
  color: #303133;
}

.phone-text, .email-text {
  color: #606266;
}

/* 状态标签样式 */
.status-tag {
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 12px;
  min-width: 60px;
  text-align: center;
}

/* 操作按钮样式 */
.custom-table ::v-deep .action-btn {
  margin: 0 2px;
  border-radius: 4px;
}

/* 弹窗样式优化 */
.employee-dialog ::v-deep .el-dialog {
  border-radius: 8px;
}

.employee-dialog ::v-deep .el-dialog__header {
  border-bottom: 1px solid #ebeef5;
  padding: 15px 20px;
}

.employee-dialog ::v-deep .el-dialog__title {
  font-size: 1.2rem;
  font-weight: 500;
  color: #303133;
}

.employee-dialog ::v-deep .el-form-item__label {
  font-weight: 500;
  color: #606266;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .info-section {
    flex-direction: column;
    align-items: flex-start;
  }

  .button-group {
    width: 100%;
    justify-content: flex-end;
  }
  .status-tag {
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 12px;
  min-width: 60px;
  text-align: center;
   }
}

.aics-background{
    display: block;
  margin:  20px auto 20px auto;
  opacity: 0.3;
  border-radius: 50%;
}
.selector ul{
  display: flex;
  list-style: none;  
}
.selector ul li{
  display: flex-inline;
  margin-left: 20px;
  cursor: pointer;
}


.plans-table-container, .fuel-table-container {
  overflow-x: auto;
}
.plans-table, .fuel-table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 0.9rem;
  margin-top: 10px;
}
.plans-table th, .plans-table td,
.addons-table th, .addons-table td {
  padding: 12px 15px;
  text-align: center;
  border: 1px solid #e0e0e0;
}
.plans-table th, .addons-table th {
  background-color: #f5f5f5;
  font-weight: 600;
  color: #333;
}
.plans-table .feature-col {
  width: 25%;
  text-align: left;
  background-color: #f9f9f9;
  font-weight: 500;
}
.plans-table .plan-col {
  width: 18.75%;
}
.plans-table .feature-name {
  text-align: left;
  background-color: #f9f9f9;
  font-weight: bold;
}
.plans-table .plan-feature {
  color: #555;
}
.plans-table .price-row .plan-feature {
  font-weight: 600;
  color: #333;
}
.addons-table .addon-feature-col {
  width: 25%;
  text-align: left;
  background-color: #f9f9f9;
  font-weight: 500;
}
.addons-table .addon-col {
  width: 25%;
}

@media (max-width: 1200px) {
  .flowchart {
    min-width: 1000px;
  }

  .step-text {
    font-size: 0.8rem;
    max-width: 70px;
  }
}
.active{
  font-family: 微软雅黑;
  font-weight: bold;
  font-size: 1.1rem;
  color: rgb(64, 158, 255);
}
.current_plan{
  margin-left: 50px;
  font-size:  small;
}
.progress-bar{
  position: relative;
  width: 100%;
  height: 50px;
  display: flex;
  padding: 5px 0 5px 0;
  background-image: linear-gradient(to right,
        transparent 10%,
        #dddddd 10%,
        #ddd 90%,
        transparent 90%);
    background-size: 100% 3px;
    background-position: center 50%;
    background-repeat: no-repeat;
  margin: -20px 0 30px 15px;
}
.step{
    margin: 0;
    display: inline-block;
    background: transparent;

    height: 60px;
    color: #333;
    padding: 5px 0 5px 0;
    width: 33%;
    text-align: center;

}
.step-no{
    padding-top: 5px;
    display: block;
    width: 31px;
    height: 25px;
    border-radius: 50%;
    margin-top: 10px;
    color: #aaaaaa;
    font-size: 1.0rem;
    font-weight: bold;
    margin-bottom: 10px;
    background-color: white;
    border: 2px solid #aaaaaa;
    margin: auto;
    z-index: 10;
}
.checkbox-label{
  font-size: small;
  color: rgb(64, 158, 255);
  margin-right: 10px;
}

.tab-bar{
  display: block;
  border-bottom: 3px solid rgb(191, 218, 245);

  width: 96%;
  margin: 2px 2% 10px 2%;
  height: 40px;
  line-height: 40px;
}
.tab {  
  display: block;
  float: left;
  width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #057FDB;
  font-size: small;
  font-family: 微软雅黑;
  border: 1px solid #057FDB;
  cursor: pointer;
}
.tab-active {  
  display: block;
  float: left;
  width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border: 1px solid #057FDB;
  background-color: #057FDB;  
  color: white; 
  cursor: pointer;
}
.button{
  display:block; 
  background-color: #409EFF; 
  color:azure; 
  padding: 5px 10px 5px 10px; 
  font-size: 0.8rem; 
  margin-left: 49%; 
  border-radius: 5px;
}
.link{
    margin-left: 10px;
    font-family: 微软雅黑;
    font-size:  9pt;
    color: #409EFF; 
    cursor: pointer;
}
.ellipsis-text {
  display: block;
  font-size: small;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>